<template>
  <div class="whatsapp-page">
    <!-- Cabeçalho da página -->
    <div class="header">
      <h1>
        <i class="fa-solid fa-bell"></i>
        Notificações
      </h1>
      <p class="subtitle">
        {{ isAdmin
          ? 'Configure WhatsApp e Telegram para resultados e fechamento'
          : 'Cadastre números WhatsApp para receber resultados e relatórios das suas regiões' }}
      </p>
    </div>

    <!-- Convites: WhatsApp | Telegram -->
    <div v-if="whatsAppInviteLink || telegramGroupInviteLink || isAdmin" class="results-invite-wrap">
      <div class="results-invite-grid">
        <a
          v-if="whatsAppInviteLink"
          class="results-invite-tile whatsapp"
          :href="whatsAppInviteLink"
          target="_blank"
          rel="noopener"
        >
          <div class="results-invite-tile-glow"></div>
          <div class="results-invite-tile-content">
            <div class="results-invite-badge">
              <i class="fab fa-whatsapp"></i>
            </div>
            <div class="results-invite-copy">
              <strong>WhatsApp</strong>
              <span>Grupo Ralph — Resultados</span>
            </div>
            <span class="results-invite-cta">
              Entrar
              <i class="fa-solid fa-arrow-right"></i>
            </span>
          </div>
          <button
            v-if="isAdmin"
            type="button"
            class="results-invite-edit"
            title="Alterar link do WhatsApp"
            @click.prevent.stop="openEditWhatsAppInviteLink"
          >
            <i class="fa-solid fa-pen"></i>
          </button>
        </a>
        <div v-else-if="isAdmin" class="results-invite-tile whatsapp empty" @click="openEditWhatsAppInviteLink">
          <div class="results-invite-tile-content">
            <div class="results-invite-badge">
              <i class="fab fa-whatsapp"></i>
            </div>
            <div class="results-invite-copy">
              <strong>WhatsApp</strong>
              <span>Definir link do grupo</span>
            </div>
            <span class="results-invite-cta">Configurar</span>
          </div>
        </div>

        <a
          v-if="telegramGroupInviteLink"
          class="results-invite-tile telegram"
          :href="telegramGroupInviteLink"
          target="_blank"
          rel="noopener"
        >
          <div class="results-invite-tile-glow"></div>
          <div class="results-invite-tile-content">
            <div class="results-invite-badge">
              <i class="fab fa-telegram"></i>
            </div>
            <div class="results-invite-copy">
              <strong>Telegram</strong>
              <span>Grupo Ralph — Resultados</span>
            </div>
            <span class="results-invite-cta">
              Entrar
              <i class="fa-solid fa-arrow-right"></i>
            </span>
          </div>
          <button
            v-if="isAdmin"
            type="button"
            class="results-invite-edit"
            title="Alterar link do Telegram"
            @click.prevent.stop="openEditGroupInviteLink"
          >
            <i class="fa-solid fa-pen"></i>
          </button>
        </a>
        <div v-else-if="isAdmin" class="results-invite-tile telegram empty" @click="openEditGroupInviteLink">
          <div class="results-invite-tile-content">
            <div class="results-invite-badge">
              <i class="fab fa-telegram"></i>
            </div>
            <div class="results-invite-copy">
              <strong>Telegram</strong>
              <span>Definir link do grupo</span>
            </div>
            <span class="results-invite-cta">Configurar</span>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isAdmin" class="channel-tabs">
      <button
        type="button"
        class="channel-tab"
        :class="{ active: activeChannel === 'whatsapp' }"
        @click="activeChannel = 'whatsapp'"
      >
        <i class="fab fa-whatsapp"></i>
        WhatsApp
        <span
          class="channel-status-pill"
          :class="whatsAppEnabled ? 'on' : 'off'"
        >
          {{ whatsAppEnabled ? 'Ativo' : 'Inativo' }}
        </span>
      </button>
      <button
        type="button"
        class="channel-tab"
        :class="{ active: activeChannel === 'telegram' }"
        @click="activeChannel = 'telegram'; loadTelegramData()"
      >
        <i class="fab fa-telegram"></i>
        Telegram
        <span
          class="channel-status-pill"
          :class="telegramEnabled ? 'on' : 'off'"
        >
          {{ telegramEnabled ? 'Ativo' : 'Inativo' }}
        </span>
      </button>
    </div>

    <!-- Loading -->
    <div v-show="loading" class="loading-container">
      <div class="loading-spinner">
        <i class="fa-solid fa-spinner fa-spin"></i>
        <span>Carregando...</span>
      </div>
    </div>

    <!-- Conteúdo principal WhatsApp -->
    <div v-show="!loading && activeChannel === 'whatsapp'" class="whatsapp-content">
      <!-- Seção de Templates (apenas admin) -->
      <div v-if="isAdmin" class="card">
        <div class="card-header">
          <h2>
            <i class="fas fa-file-lines"></i>
            Templates de Notificação
          </h2>
          <button 
            v-if="!editingConfig"
            type="button" 
            class="btn-primary" 
            @click="createConfig()"
          >
            <i class="fa-solid fa-plus"></i>
            Novo Template
          </button>
        </div>

        <!-- Lista de Templates -->
        <div v-if="configs.length > 0" class="templates-list">
          <div 
            v-for="config in configs" 
            :key="config.id"
            class="template-card"
            :class="{ active: config.isActive }"
          >
            <div class="template-header">
              <div class="template-info">
                <h4 class="template-title">
                  <i class="fa-solid fa-file-text"></i>
                  Template {{ configs.indexOf(config) + 1 }}
                  <span :class="['status-badge', config.isActive ? 'badge-success' : 'badge-danger']">
                    <i :class="config.isActive ? 'fa-solid fa-check-circle' : 'fa-solid fa-times-circle'"></i>
                    {{ config.isActive ? 'Ativo' : 'Inativo' }}
                  </span>
                </h4>
                <p class="template-date">
                  Criado em: {{ formatDate(config.createdAt) }}
                </p>
              </div>
              <div class="template-actions">
                <button 
                  class="btn-action btn-test" 
                  @click="openTestModal(config)"
                  title="Testar Envio"
                >
                  <i class="fas fa-paper-plane"></i>
                </button>
                <button 
                  class="btn-action btn-edit" 
                  @click="editConfig(config)"
                  title="Editar"
                >
                  <i class="fa-solid fa-pen-to-square"></i>
                </button>
                <button 
                  class="btn-action btn-delete" 
                  @click="deleteConfig(config.id)"
                  title="Excluir"
                >
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
            </div>
            <div class="template-preview">
              <p class="preview-label">Preview da Mensagem:</p>
              <div class="preview-content">
                {{ config.messageTemplate }}
              </div>
            </div>
          </div>
        </div>

        <!-- Estado vazio -->
        <div v-else class="empty-state">
          <i class="fa-solid fa-file-lines"></i>
          <p>Nenhum template cadastrado</p>
          <button type="button" class="btn-primary" @click="createConfig()">
            <i class="fa-solid fa-plus"></i>
            Criar Primeiro Template
          </button>
        </div>

      </div>

      <!-- Seção de Números -->
      <div class="card">
        <div class="card-header">
          <h2>
            <i class="fas fa-phone"></i>
            Grupos e Canais WhatsApp
          </h2>
          <button 
            v-if="!editingNumber && activeConfig"
            type="button" 
            class="btn-primary" 
            @click="createNumber()"
          >
            <i class="fa-solid fa-plus"></i>
            Adicionar Destino
          </button>
        </div>

        <div v-if="!activeConfig" class="info-message">
          <i class="fa-solid fa-info-circle"></i>
          <p>
            {{ isAdmin
              ? 'Você precisa ter pelo menos um template ativo para cadastrar destinos.'
              : 'Não há template de notificação ativo. Solicite ao administrador para ativar um template.' }}
          </p>
        </div>
        <div v-else class="info-message" style="margin-bottom: 12px;">
          <i class="fa-solid fa-info-circle"></i>
          <p>
            Resultados automáticos são enviados <strong>somente para grupos</strong> (<code>@g.us</code>)
            e <strong>canais</strong> (<code>@newsletter</code>). Números individuais não recebem resultados.
          </p>
        </div>

        <!-- Tutorial grupo WhatsApp -->
        <div v-if="activeConfig" class="whatsapp-group-tutorial">
          <button
            type="button"
            class="btn-secondary"
            @click="showWhatsAppGroupTutorial = !showWhatsAppGroupTutorial"
          >
            <i class="fa-solid fa-users"></i>
            {{ showWhatsAppGroupTutorial ? 'Ocultar tutorial grupo/canal' : 'Como cadastrar grupo ou canal WhatsApp' }}
          </button>
          <div v-show="showWhatsAppGroupTutorial" class="telegram-tutorial" style="margin-top: 12px;">
            <div class="tutorial-block">
              <ol>
                <li>Crie o <strong>grupo</strong> ou o <strong>canal</strong> no WhatsApp.</li>
                <li>A <strong>instância WhatsApp</strong> do sistema precisa estar no grupo (ou ser admin do canal para publicar).</li>
                <li>
                  Copie o ID:
                  <ul>
                    <li>Grupo → termina com <code>@g.us</code></li>
                    <li>Canal → termina com <code>@newsletter</code></li>
                  </ul>
                </li>
                <li>Em <strong>Adicionar Destino</strong>, escolha <strong>Grupo</strong> ou <strong>Canal</strong>, cole o ID, defina a região e salve.</li>
              </ol>
            </div>
          </div>
        </div>

        <!-- Lista de Números -->
        <div v-if="activeConfig && numbers.length > 0" class="numbers-list">
          <div 
            v-for="number in numbers" 
            :key="number.id"
            class="number-card"
            :class="{ active: number.isActive }"
          >
            <div class="number-info">
              <div class="number-main">
                <i :class="whatsAppDestinationIcon(number.phoneNumber)"></i>
                <div class="number-details">
                  <h4 class="number-phone">{{ formatDestination(number.phoneNumber) }}</h4>
                  <p class="number-name" v-if="number.name">{{ number.name }}</p>
                  <p class="number-region">
                    <i :class="whatsAppDestinationIcon(number.phoneNumber)"></i>
                    {{ whatsAppDestinationLabel(number.phoneNumber) }}
                  </p>
                  <p class="number-region" v-if="number.regionName">
                    <i class="fa-solid fa-map-marker-alt"></i>
                    Região: {{ number.regionName }}
                  </p>
                  <p class="number-region" v-else>
                    <i class="fa-solid fa-globe"></i>
                    Notificação Global
                  </p>
                </div>
              </div>
              <div class="number-status">
                <span :class="['status-badge', number.isActive ? 'badge-success' : 'badge-danger']">
                  <i :class="number.isActive ? 'fa-solid fa-check-circle' : 'fa-solid fa-times-circle'"></i>
                  {{ number.isActive ? 'Ativo' : 'Inativo' }}
                </span>
              </div>
            </div>
            <div class="number-actions">
              <button 
                class="btn-action btn-edit" 
                @click="editNumber(number)"
                title="Editar"
              >
                <i class="fa-solid fa-pen-to-square"></i>
              </button>
              <button 
                class="btn-action btn-delete" 
                @click="deleteNumber(number.id)"
                title="Excluir"
              >
                <i class="fa-solid fa-trash"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Estado vazio -->
        <div v-else-if="activeConfig" class="empty-state">
          <i class="fa-solid fa-phone"></i>
          <p>Nenhum número ou grupo cadastrado</p>
          <button type="button" class="btn-primary" @click="createNumber()">
            <i class="fa-solid fa-plus"></i>
            Adicionar Primeiro Destino
          </button>
        </div>

      </div>

      <!-- Seção de Relatórios (apenas admin) -->
      <div v-if="isAdmin" class="card">
        <div class="card-header">
          <h2>
            <i class="fas fa-chart-line"></i>
            Relatórios de Encerramento
          </h2>
          <button 
            v-if="!editingReportTemplate"
            type="button" 
            class="btn-primary" 
            @click="createReportTemplate()"
          >
            <i class="fa-solid fa-plus"></i>
            Novo Template de Relatório
          </button>
        </div>

        <!-- Lista de Templates de Relatório -->
        <div v-if="reportTemplates.length > 0" class="templates-list">
          <div 
            v-for="template in reportTemplates" 
            :key="template.id"
            class="template-card"
            :class="{ active: template.isActive }"
          >
            <div class="template-header">
              <div class="template-info">
                <h4 class="template-title">{{ template.name }}</h4>
                <p class="template-date">
                  Criado em: {{ new Date(template.createdAt).toLocaleDateString('pt-BR') }}
                </p>
              </div>
              <div class="template-status">
                <span :class="['status-badge', template.isActive ? 'badge-success' : 'badge-danger']">
                  <i :class="template.isActive ? 'fa-solid fa-check-circle' : 'fa-solid fa-times-circle'"></i>
                  {{ template.isActive ? 'Ativo' : 'Inativo' }}
                </span>
              </div>
            </div>
            <div class="template-actions">
              <button 
                class="btn-action btn-ranking" 
                @click="editRankingTemplate(template)"
                title="Editar Template de Ranking"
              >
                <i class="fa-solid fa-trophy"></i>
                Ranking
              </button>
              <button 
                class="btn-action btn-edit" 
                @click="editReportTemplate(template)"
                title="Editar"
              >
                <i class="fa-solid fa-pen-to-square"></i>
              </button>
              <button 
                class="btn-action btn-delete" 
                @click="deleteReportTemplate(template.id)"
                title="Excluir"
              >
                <i class="fa-solid fa-trash"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Estado vazio -->
        <div v-else class="empty-state">
          <i class="fa-solid fa-file-lines"></i>
          <p>Nenhum template de relatório cadastrado</p>
          <button type="button" class="btn-primary" @click="createReportTemplate()">
            <i class="fa-solid fa-plus"></i>
            Criar Primeiro Template
          </button>
        </div>


        <!-- Seção de Agendamentos -->
        <div class="card" style="margin-top: 2rem;">
          <div class="card-header">
            <h2>
              <i class="fas fa-clock"></i>
              Agendamentos de Relatórios
            </h2>
            <button 
              v-if="!editingReportSchedule && reportTemplates.length > 0 && numbers.length > 0"
              type="button" 
              class="btn-primary" 
              @click="createReportSchedule()"
            >
              <i class="fa-solid fa-plus"></i>
              Novo Agendamento
            </button>
          </div>

          <!-- Lista de Agendamentos -->
          <div v-if="reportSchedules.length > 0" class="schedules-list">
            <div 
              v-for="schedule in reportSchedules" 
              :key="schedule.id"
              class="schedule-card"
            >
              <div class="schedule-header">
                <div class="schedule-info">
                  <h4 class="schedule-title">{{ schedule.templateName || 'Template' }}</h4>
                  <p class="schedule-details">
                    <i class="fas fa-phone"></i>
                    {{ schedule.numberPhone }} ({{ schedule.numberName || 'Sem nome' }})
                  </p>
                  <p class="schedule-details" v-if="schedule.regionName">
                    <i class="fa-solid fa-map-marker-alt"></i>
                    Região: {{ schedule.regionName }}
                  </p>
                  <p class="schedule-details">
                    <i class="fas fa-clock"></i>
                    {{ schedule.scheduleTypeDescription }}: 
                    <span v-if="schedule.scheduleType === 0">{{ schedule.fixedHour }}:00</span>
                    <span v-else>A cada {{ schedule.intervalHours }} horas</span>
                  </p>
                  <p class="schedule-details" v-if="schedule.lastSentAt">
                    <i class="fa-solid fa-check"></i>
                    Último envio: {{ new Date(schedule.lastSentAt).toLocaleString('pt-BR') }}
                  </p>
                </div>
                <div class="schedule-status">
                  <span :class="['status-badge', schedule.isActive ? 'badge-success' : 'badge-danger']">
                    <i :class="schedule.isActive ? 'fa-solid fa-check-circle' : 'fa-solid fa-times-circle'"></i>
                    {{ schedule.isActive ? 'Ativo' : 'Inativo' }}
                  </span>
                </div>
              </div>
              <div class="schedule-actions">
                <button 
                  class="btn-action btn-edit" 
                  @click="editReportSchedule(schedule)"
                  title="Editar"
                >
                  <i class="fa-solid fa-pen-to-square"></i>
                </button>
                <button 
                  class="btn-action btn-delete" 
                  @click="deleteReportSchedule(schedule.id)"
                  title="Excluir"
                >
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- Estado vazio -->
          <div v-else class="empty-state">
            <i class="fas fa-clock"></i>
            <p>Nenhum agendamento cadastrado</p>
            <button 
              v-if="reportTemplates.length > 0 && numbers.length > 0"
              type="button" 
              class="btn-primary" 
              @click="createReportSchedule()"
            >
              <i class="fa-solid fa-plus"></i>
              Criar Primeiro Agendamento
            </button>
            <p v-else class="empty-state-hint">
              Você precisa ter pelo menos um template e um número cadastrado
            </p>
          </div>

        </div>
      </div>
    </div>

    <!-- Conteúdo Telegram (apenas admin) -->
    <div v-if="isAdmin" v-show="!loading && activeChannel === 'telegram'" class="whatsapp-content telegram-content">
      <div class="card">
        <div class="card-header">
          <h2>
            <i class="fab fa-telegram"></i>
            Bot Telegram
          </h2>
          <div class="toggle-container header-toggle">
            <label class="toggle-switch">
              <input
                type="checkbox"
                :checked="telegramEnabled"
                :disabled="!telegramBot.id && !telegramBotForm.botToken"
                @change="toggleTelegramEnabled($event.target.checked)"
              />
              <span class="toggle-slider"></span>
            </label>
            <span class="toggle-label">
              {{ telegramEnabled ? 'Notificações Telegram ativas' : 'Notificações Telegram desativadas' }}
            </span>
          </div>
        </div>

        <div class="info-message">
          <i class="fa-solid fa-info-circle"></i>
          <p>
            Crie um bot com <strong>@BotFather</strong>, cole o token aqui e ative.
            Resultado dispara após processar o sorteio; fechamento segue os agendamentos.
          </p>
        </div>

        <div class="form-grid telegram-bot-form">
          <div class="form-group">
            <label class="form-label">Token do Bot *</label>
            <input
              type="text"
              class="form-input"
              v-model="telegramBotForm.botToken"
              :placeholder="telegramBot.id ? 'Deixe em branco para manter o token atual' : '123456:ABC-DEF...'"
            />
            <small v-if="telegramBot.botToken" class="form-hint">Token atual: {{ telegramBot.botToken }}</small>
          </div>
          <div class="form-group">
            <label class="form-label">Username do Bot *</label>
            <input
              type="text"
              class="form-input"
              v-model="telegramBotForm.botUsername"
              placeholder="@meu_bot"
            />
            <small class="form-hint">
              Necessário para o link de início do chat.
              <a
                v-if="telegramBotDeepLink"
                :href="telegramBotDeepLink"
                target="_blank"
                rel="noopener"
              >Abrir {{ telegramBotUsernameDisplay }}</a>
            </small>
          </div>
          <div class="form-group telegram-group-link-field">
            <label class="form-label">
              <i class="fab fa-telegram"></i>
              Link do grupo Telegram
            </label>
            <input
              type="text"
              class="form-input"
              v-model="telegramBotForm.groupInviteLink"
              placeholder="https://t.me/+0W_cxW1tSPw1YTAx"
            />
          </div>
          <div class="form-group telegram-group-link-field">
            <label class="form-label">
              <i class="fab fa-whatsapp"></i>
              Link do grupo WhatsApp
            </label>
            <input
              type="text"
              class="form-input"
              v-model="telegramBotForm.whatsAppInviteLink"
              placeholder="https://chat.whatsapp.com/DclBTtClfLh5atqjj6G7rY"
            />
          </div>
          <div class="form-group form-actions-inline">
            <button type="button" class="btn-primary" @click="saveTelegramBot" :disabled="savingTelegramBot">
              <i class="fa-solid fa-save"></i>
              {{ telegramBot.id ? 'Atualizar Bot' : 'Salvar Bot' }}
            </button>
          </div>
        </div>
      </div>

      <!-- Tutorial: cadastro de chat particular -->
      <div class="card telegram-tutorial-card">
        <div class="card-header">
          <h2>
            <i class="fa-solid fa-graduation-cap"></i>
            Como cadastrar um número (chat particular)
          </h2>
          <button
            type="button"
            class="btn-secondary"
            @click="showTelegramTutorial = !showTelegramTutorial"
          >
            <i :class="showTelegramTutorial ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
            {{ showTelegramTutorial ? 'Ocultar' : 'Ver tutorial' }}
          </button>
        </div>

        <div v-show="showTelegramTutorial" class="telegram-tutorial">
          <div class="tutorial-block">
            <ol>
              <li>
                Abra o bot
                <a
                  v-if="telegramBotDeepLink"
                  :href="telegramBotDeepLink"
                  target="_blank"
                  rel="noopener"
                >{{ telegramBotUsernameDisplay || '@Ralphresultsbot' }}</a>
                <strong v-else>{{ telegramBotUsernameDisplay || '@Ralphresultsbot' }}</strong>
                no Telegram.
              </li>
              <li>Envie <strong>/start</strong>.</li>
              <li>Copie o <strong>Chat ID</strong> que o bot enviar.</li>
              <li>Em <strong>Chats / Grupos</strong> → <strong>Adicionar Chat</strong>, cole o ID, marque <strong>Receber mensagens do bot</strong> e salve.</li>
            </ol>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h2>
            <i class="fa-solid fa-comments"></i>
            Chats / Grupos
          </h2>
          <div style="display: flex; gap: 8px; flex-wrap: wrap;">
            <button
              type="button"
              class="btn-secondary"
              @click="openTelegramTestModal(null)"
              :disabled="!telegramBot.id || telegramChats.length === 0 || !telegramEnabled"
              title="Escolher chat e enviar teste"
            >
              <i class="fas fa-paper-plane"></i>
              Testar envio
            </button>
            <button type="button" class="btn-primary" @click="createTelegramChat" :disabled="!telegramBot.id">
              <i class="fa-solid fa-plus"></i>
              Adicionar Chat
            </button>
          </div>
        </div>

        <div v-if="!telegramBot.id" class="info-message">
          <i class="fa-solid fa-info-circle"></i>
          <p>Cadastre e salve o bot antes de adicionar chats.</p>
        </div>

        <div v-else-if="telegramChats.length > 0" class="numbers-list">
          <div
            v-for="chat in telegramChats"
            :key="chat.id"
            class="number-card"
            :class="{ active: chat.isActive }"
          >
            <div class="number-info">
              <div class="number-main">
                <i class="fab fa-telegram"></i>
                <div class="number-details">
                  <h4 class="number-phone">{{ chat.name || chat.chatId }}</h4>
                  <p class="number-name">Chat ID: {{ chat.chatId }}</p>
                  <p class="number-region" v-if="chat.regionName">
                    <i class="fa-solid fa-map-marker-alt"></i>
                    Região: {{ chat.regionName }}
                  </p>
                  <p class="number-region" v-else>
                    <i class="fa-solid fa-globe"></i>
                    Notificação Global
                  </p>
                  <p class="number-region">
                    <i class="fa-solid fa-robot"></i>
                    Mensagens do bot: {{ chat.receiveResults ? 'Sim' : 'Não' }}
                  </p>
                </div>
              </div>
              <div class="number-status">
                <span :class="['status-badge', chat.isActive ? 'badge-success' : 'badge-danger']">
                  {{ chat.isActive ? 'Ativo' : 'Inativo' }}
                </span>
              </div>
            </div>
            <div class="number-actions">
              <button
                class="btn-action btn-test"
                @click="sendTelegramTestToChat(chat)"
                :disabled="sendingTelegramTestChatId === chat.id || !telegramEnabled"
                :title="telegramEnabled ? 'Enviar mensagem de teste' : 'Ative o bot Telegram primeiro'"
              >
                <i :class="sendingTelegramTestChatId === chat.id ? 'fa-solid fa-spinner fa-spin' : 'fas fa-paper-plane'"></i>
              </button>
              <button class="btn-action btn-edit" @click="editTelegramChat(chat)" title="Editar">
                <i class="fa-solid fa-pen-to-square"></i>
              </button>
              <button class="btn-action btn-delete" @click="deleteTelegramChat(chat.id)" title="Excluir">
                <i class="fa-solid fa-trash"></i>
              </button>
            </div>
          </div>
        </div>

        <div v-else class="empty-state">
          <i class="fab fa-telegram"></i>
          <p>Nenhum chat cadastrado</p>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h2>
            <i class="fas fa-file-lines"></i>
            Template de Resultado (Telegram)
          </h2>
          <button type="button" class="btn-primary" @click="createTelegramConfig">
            <i class="fa-solid fa-plus"></i>
            Novo Template
          </button>
        </div>

        <div v-if="telegramConfigs.length > 0" class="templates-list">
          <div
            v-for="(config, idx) in telegramConfigs"
            :key="config.id"
            class="template-card"
            :class="{ active: config.isActive }"
          >
            <div class="template-header">
              <div class="template-info">
                <h4 class="template-title">
                  Template {{ idx + 1 }}
                  <span v-if="config.isActive" class="active-badge">Ativo</span>
                </h4>
              </div>
              <div class="template-actions">
                <button class="btn-action btn-test" @click="openTelegramTestModal(config)" title="Testar">
                  <i class="fas fa-paper-plane"></i>
                </button>
                <button class="btn-action btn-edit" @click="editTelegramConfig(config)">
                  <i class="fa-solid fa-pen-to-square"></i>
                </button>
                <button class="btn-action btn-delete" @click="deleteTelegramConfig(config.id)">
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
            </div>
            <div class="template-preview">
              <div class="preview-content">{{ config.messageTemplate }}</div>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <p>Nenhum template de resultado Telegram</p>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h2>
            <i class="fas fa-chart-line"></i>
            Relatórios de Encerramento (Telegram)
          </h2>
          <button type="button" class="btn-primary" @click="createTelegramReportTemplate">
            <i class="fa-solid fa-plus"></i>
            Novo Template
          </button>
        </div>

        <div v-if="telegramReportTemplates.length > 0" class="templates-list">
          <div
            v-for="template in telegramReportTemplates"
            :key="template.id"
            class="template-card"
            :class="{ active: template.isActive }"
          >
            <div class="template-header">
              <div class="template-info">
                <h4 class="template-title">
                  {{ template.name }}
                  <span v-if="template.isActive" class="active-badge">Ativo</span>
                </h4>
              </div>
              <div class="template-actions">
                <button class="btn-action btn-edit" @click="editTelegramReportTemplate(template)">
                  <i class="fa-solid fa-pen-to-square"></i>
                </button>
                <button class="btn-action btn-delete" @click="deleteTelegramReportTemplate(template.id)">
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
            </div>
            <div class="template-preview">
              <div class="preview-content">{{ template.dailyReportTemplate }}</div>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <p>Nenhum template de fechamento Telegram</p>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h2>
            <i class="fas fa-clock"></i>
            Agendamentos (Telegram)
          </h2>
          <button
            type="button"
            class="btn-primary"
            @click="createTelegramReportSchedule"
            :disabled="!telegramReportTemplates.length || !telegramChats.length"
          >
            <i class="fa-solid fa-plus"></i>
            Novo Agendamento
          </button>
        </div>

        <div v-if="telegramReportSchedules.length > 0" class="numbers-list">
          <div
            v-for="schedule in telegramReportSchedules"
            :key="schedule.id"
            class="number-card"
            :class="{ active: schedule.isActive }"
          >
            <div class="number-info">
              <div class="number-main">
                <i class="fa-solid fa-clock"></i>
                <div class="number-details">
                  <h4 class="number-phone">
                    {{ schedule.scheduleType === 0 ? `Horário fixo ${String(schedule.fixedHour).padStart(2,'0')}:00` : `A cada ${schedule.intervalHours}h` }}
                  </h4>
                  <p class="number-name">Chat: {{ schedule.chatName || schedule.telegramChatId || schedule.chatId }}</p>
                  <p class="number-region">Template: {{ schedule.templateName || schedule.templateId }}</p>
                </div>
              </div>
              <div class="number-status">
                <span :class="['status-badge', schedule.isActive ? 'badge-success' : 'badge-danger']">
                  {{ schedule.isActive ? 'Ativo' : 'Inativo' }}
                </span>
              </div>
            </div>
            <div class="number-actions">
              <button class="btn-action btn-edit" @click="editTelegramReportSchedule(schedule)">
                <i class="fa-solid fa-pen-to-square"></i>
              </button>
              <button class="btn-action btn-delete" @click="deleteTelegramReportSchedule(schedule.id)">
                <i class="fa-solid fa-trash"></i>
              </button>
            </div>
          </div>
        </div>
        <div v-else class="empty-state">
          <p>Nenhum agendamento Telegram</p>
        </div>
      </div>
    </div>

    <!-- Modal de Template -->
    <div v-if="editingConfig" class="modal-overlay" @click="cancelEdit">
      <div class="modal-content config-modal" @click.stop>
        <div class="modal-header">
          <h3 class="modal-title">
            <i class="fa-solid fa-edit"></i>
            {{ currentConfig.id ? 'Editar Template' : 'Novo Template' }}
          </h3>
          <button class="modal-close" @click="cancelEdit">
            <i class="fa-solid fa-times"></i>
          </button>
        </div>

        <div class="modal-body">
          <div class="form-group">
            <label class="form-label">
              <i class="fa-solid fa-file-text"></i>
              Template da Mensagem *
              <button 
                type="button" 
                class="btn-placeholders" 
                @click="showNotificationPlaceholdersModal = true"
                title="Ver placeholders disponíveis"
              >
                <i class="fa-solid fa-info-circle"></i>
                Placeholders
              </button>
            </label>
            <textarea 
              class="form-textarea"
              v-model="currentConfig.messageTemplate"
              rows="8"
              placeholder="Digite o template da mensagem. Use {LotteryName}, {LotteryDetail}, {Date}, {Numbers}, {1st}, {2nd}, etc. como placeholders"
              maxlength="500"
            ></textarea>
          </div>

          <div class="form-group">
            <label class="form-label">
              <i class="fa-solid fa-toggle-on"></i>
              Status
            </label>
            <div class="toggle-container">
              <label class="toggle-switch">
                <input 
                  type="checkbox" 
                  v-model="currentConfig.isActive"
                />
                <span class="toggle-slider"></span>
              </label>
              <span class="toggle-label">
                {{ currentConfig.isActive ? 'Ativo' : 'Inativo' }}
              </span>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-secondary" @click="cancelEdit">
            <i class="fa-solid fa-times"></i>
            Cancelar
          </button>
          <button type="button" class="btn-primary" @click="saveConfig()">
            <i class="fa-solid fa-save"></i>
            Salvar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de Número -->
    <div v-if="editingNumber" class="modal-overlay" @click="cancelEditNumber">
      <div class="modal-content number-modal" @click.stop>
        <div class="modal-header">
          <h3 class="modal-title">
            <i class="fa-solid fa-edit"></i>
            {{ currentNumber.id ? 'Editar Destino' : 'Novo Destino WhatsApp' }}
          </h3>
          <button class="modal-close" @click="cancelEditNumber">
            <i class="fa-solid fa-times"></i>
          </button>
        </div>

        <div class="modal-body">
          <div class="form-group">
            <label class="form-label">Tipo de destino *</label>
            <div class="destination-type-toggle">
              <button
                type="button"
                class="destination-type-btn"
                :class="{ active: numberDestinationType === 'group' }"
                @click="numberDestinationType = 'group'"
              >
                <i class="fa-solid fa-users"></i>
                Grupo
              </button>
              <button
                type="button"
                class="destination-type-btn"
                :class="{ active: numberDestinationType === 'channel' }"
                @click="numberDestinationType = 'channel'"
              >
                <i class="fa-solid fa-bullhorn"></i>
                Canal
              </button>
            </div>
            <small class="form-hint">Resultados só são enviados para grupo ou canal.</small>
          </div>

          <div class="form-group">
            <label class="form-label">
              <i :class="destinationTypeIcon"></i>
              {{ destinationTypeFieldLabel }}
            </label>
            <input 
              type="text" 
              class="form-input"
              v-model="currentNumber.phoneNumber"
              :placeholder="destinationTypePlaceholder"
              maxlength="100"
            />
            <small class="form-hint">
              <i class="fa-solid fa-info-circle"></i>
              {{ destinationTypeHint }}
            </small>
          </div>

          <div class="form-group">
            <label class="form-label">
              <i class="fa-solid fa-user"></i>
              Nome (Opcional)
            </label>
            <input 
              type="text" 
              class="form-input"
              v-model="currentNumber.name"
              placeholder="Nome para identificar o número"
              maxlength="100"
            />
          </div>

          <div class="form-group">
            <label class="form-label">
              <i class="fa-solid fa-map-marker-alt"></i>
              {{ isAdmin ? 'Região (Opcional)' : 'Região *' }}
            </label>
            <select 
              class="form-input"
              v-model="currentNumber.regionId"
            >
              <option v-if="isAdmin" :value="null">Todas as Regiões (Global)</option>
              <option v-else :value="null" disabled>Selecione uma região</option>
              <option 
                v-for="region in regions" 
                :key="region.id" 
                :value="region.id"
              >
                {{ region.name }}
              </option>
            </select>
            <small class="form-hint">
              <i class="fa-solid fa-info-circle"></i>
              {{ isAdmin
                ? 'Se selecionar uma região, o número receberá notificações apenas dessa região. Se deixar em branco, receberá de todas.'
                : 'O número receberá resultados e relatórios apenas da região selecionada.' }}
            </small>
          </div>

          <div class="form-group">
            <label class="form-label">
              <i class="fas fa-file-lines"></i>
              Templates de Relatório (Opcional)
            </label>
            <div class="templates-checkbox-group">
              <div 
                v-for="template in reportTemplates" 
                :key="template.id"
                class="template-checkbox-item"
              >
                <label class="checkbox-label">
                  <input 
                    type="checkbox"
                    :value="template.id"
                    v-model="currentNumber.selectedReportTemplateIds"
                  />
                  <span class="checkbox-text">
                    <i class="fa-solid fa-file-text"></i>
                    {{ template.name }}
                  </span>
                </label>
              </div>
              <p v-if="reportTemplates.length === 0" class="form-hint">
                {{ isAdmin
                  ? 'Nenhum template de relatório cadastrado. Crie templates na seção de Relatórios.'
                  : 'Nenhum template de relatório disponível. Solicite ao administrador.' }}
              </p>
            </div>
            <small class="form-hint">
              <i class="fa-solid fa-info-circle"></i>
              {{ isAdmin
                ? 'Selecione quais templates de relatório este número deve receber. Se nenhum for selecionado, o número não receberá relatórios.'
                : 'Marque os templates para receber o relatório de fechamento da região (agendamento automático às 08:00).' }}
            </small>
          </div>

          <div class="form-group">
            <label class="form-label">
              <i class="fa-solid fa-toggle-on"></i>
              Status
            </label>
            <div class="toggle-container">
              <label class="toggle-switch">
                <input 
                  type="checkbox" 
                  v-model="currentNumber.isActive"
                />
                <span class="toggle-slider"></span>
              </label>
              <span class="toggle-label">
                {{ currentNumber.isActive ? 'Ativo' : 'Inativo' }}
              </span>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-secondary" @click="cancelEditNumber">
            <i class="fa-solid fa-times"></i>
            Cancelar
          </button>
          <button type="button" class="btn-primary" @click="saveNumber()">
            <i class="fa-solid fa-save"></i>
            Salvar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de Template de Relatório -->
    <div v-if="editingReportTemplate" class="modal-overlay" @click="cancelEditReportTemplate">
      <div class="modal-content report-template-modal" @click.stop>
        <div class="modal-header">
          <h3 class="modal-title">
            <i class="fa-solid fa-edit"></i>
            {{ currentReportTemplate.id ? 'Editar' : 'Novo' }} Template de Relatório
          </h3>
          <button class="modal-close" @click="cancelEditReportTemplate">
            <i class="fa-solid fa-times"></i>
          </button>
        </div>

        <div class="modal-body">
          <div class="form-group">
            <label class="form-label">
              <i class="fa-solid fa-tag"></i>
              Nome do Template
            </label>
            <input 
              type="text" 
              class="form-input"
              v-model="currentReportTemplate.name"
              placeholder="Ex: Relatório Diário Completo"
              maxlength="100"
            />
          </div>

          <div class="form-group">
            <label class="form-label">
              <i class="fa-solid fa-file-text"></i>
              Template do Relatório Diário
              <button 
                type="button" 
                class="btn-placeholders" 
                @click="showPlaceholdersModal = true"
                title="Ver placeholders disponíveis"
              >
                <i class="fa-solid fa-info-circle"></i>
                Placeholders
              </button>
            </label>
            <textarea 
              class="form-textarea"
              v-model="currentReportTemplate.dailyReportTemplate"
              rows="8"
              placeholder="Digite o template do relatório diário. Use {Date}, {TotalSales}, {TotalPrizes}, {BancaRecebeu}, {BancaPagou}, {Lotteries}, {Ranking} como placeholders"
              maxlength="2000"
            ></textarea>
          </div>

          <div class="form-group">
            <label class="form-label">
              <i class="fa-solid fa-toggle-on"></i>
              Status
            </label>
            <div class="toggle-container">
              <label class="toggle-switch">
                <input 
                  type="checkbox" 
                  v-model="currentReportTemplate.isActive"
                />
                <span class="toggle-slider"></span>
              </label>
              <span class="toggle-label">
                {{ currentReportTemplate.isActive ? 'Ativo' : 'Inativo' }}
              </span>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-secondary" @click="cancelEditReportTemplate">
            <i class="fa-solid fa-times"></i>
            Cancelar
          </button>
          <button type="button" class="btn-primary" @click="saveReportTemplate()">
            <i class="fa-solid fa-save"></i>
            Salvar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de Agendamento -->
    <div v-if="editingReportSchedule" class="modal-overlay" @click="cancelEditReportSchedule">
      <div class="modal-content schedule-modal" @click.stop>
        <div class="modal-header">
          <h3 class="modal-title">
            <i class="fa-solid fa-edit"></i>
            {{ currentReportSchedule.id ? 'Editar' : 'Novo' }} Agendamento
          </h3>
          <button class="modal-close" @click="cancelEditReportSchedule">
            <i class="fa-solid fa-times"></i>
          </button>
        </div>

        <div class="modal-body">
          <div class="form-group">
            <label class="form-label">
              <i class="fas fa-file-lines"></i>
              Template
            </label>
            <select 
              class="form-input"
              v-model="currentReportSchedule.templateId"
            >
              <option value="">Selecione um template</option>
              <option 
                v-for="template in reportTemplates" 
                :key="template.id"
                :value="template.id"
              >
                {{ template.name }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label class="form-label">
              <i class="fas fa-phone"></i>
              Número
            </label>
            <select 
              class="form-input"
              v-model="currentReportSchedule.numberId"
            >
              <option value="">Selecione um número</option>
              <option 
                v-for="number in numbers" 
                :key="number.id"
                :value="number.id"
              >
                {{ number.phoneNumber }} ({{ number.name || 'Sem nome' }})
              </option>
            </select>
          </div>

          <div class="form-group">
            <label class="form-label">
              <i class="fa-solid fa-map-marker-alt"></i>
              Região (Opcional)
            </label>
            <select 
              class="form-input"
              v-model="currentReportSchedule.regionId"
            >
              <option :value="null">Todas as regiões</option>
              <option 
                v-for="region in regions" 
                :key="region.id"
                :value="region.id"
              >
                {{ region.name }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label class="form-label">
              <i class="fas fa-clock"></i>
              Tipo de Agendamento
            </label>
            <select 
              class="form-input"
              v-model="currentReportSchedule.scheduleType"
            >
              <option :value="0">Horário Fixo</option>
              <option :value="1">Intervalo</option>
            </select>
          </div>

          <div class="form-group" v-if="currentReportSchedule.scheduleType === 0">
            <label class="form-label">
              <i class="fas fa-clock"></i>
              Horário (0-23)
            </label>
            <input 
              type="number" 
              class="form-input"
              v-model.number="currentReportSchedule.fixedHour"
              min="0"
              max="23"
              placeholder="Ex: 18"
            />
          </div>

          <div class="form-group" v-if="currentReportSchedule.scheduleType === 1">
            <label class="form-label">
              <i class="fas fa-clock"></i>
              Intervalo em Horas (1-24)
            </label>
            <input 
              type="number" 
              class="form-input"
              v-model.number="currentReportSchedule.intervalHours"
              min="1"
              max="24"
              placeholder="Ex: 6"
            />
          </div>

          <div class="form-group">
            <label class="form-label">
              <i class="fa-solid fa-toggle-on"></i>
              Status
            </label>
            <div class="toggle-container">
              <label class="toggle-switch">
                <input 
                  type="checkbox" 
                  v-model="currentReportSchedule.isActive"
                />
                <span class="toggle-slider"></span>
              </label>
              <span class="toggle-label">
                {{ currentReportSchedule.isActive ? 'Ativo' : 'Inativo' }}
              </span>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-secondary" @click="cancelEditReportSchedule">
            <i class="fa-solid fa-times"></i>
            Cancelar
          </button>
          <button type="button" class="btn-primary" @click="saveReportSchedule()">
            <i class="fa-solid fa-save"></i>
            Salvar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de Placeholders para Relatórios -->
    <div v-if="showPlaceholdersModal" class="modal-overlay" @click="showPlaceholdersModal = false">
      <div class="modal-content placeholders-modal" @click.stop>
        <div class="modal-header">
          <h3 class="modal-title">
            <i class="fa-solid fa-info-circle"></i>
            Placeholders Disponíveis - Relatórios
          </h3>
          <button class="modal-close" @click="showPlaceholdersModal = false">
            <i class="fa-solid fa-times"></i>
          </button>
        </div>

        <div class="modal-body">
          <div class="placeholders-info">
            <div class="placeholders-grid">
              <div class="placeholder-group">
                <div 
                  class="placeholder-group-header" 
                  @click="expandedPlaceholderGroups.reportBasic = !expandedPlaceholderGroups.reportBasic"
                >
                  <h5 class="placeholder-group-title">📋 Informações do Relatório</h5>
                  <i :class="['fa-solid', expandedPlaceholderGroups.reportBasic ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
                </div>
                <div 
                  v-show="expandedPlaceholderGroups.reportBasic"
                  class="placeholder-list"
                >
                  <div class="placeholder-item">
                    <span class="placeholder-tag">{Date}</span>
                    <span class="placeholder-desc">Data do relatório</span>
                  </div>
                  <div class="placeholder-item">
                    <span class="placeholder-tag">{TotalSales}</span>
                    <span class="placeholder-desc">Total de vendas</span>
                  </div>
                  <div class="placeholder-item">
                    <span class="placeholder-tag">{TotalPrizes}</span>
                    <span class="placeholder-desc">Total de prêmios</span>
                  </div>
                  <div class="placeholder-item">
                    <span class="placeholder-tag">{BancaRecebeu}</span>
                    <span class="placeholder-desc">Total que a banca recebeu</span>
                  </div>
                  <div class="placeholder-item">
                    <span class="placeholder-tag">{BancaPagou}</span>
                    <span class="placeholder-desc">Total que a banca pagou</span>
                  </div>
                  <div class="placeholder-item">
                    <span class="placeholder-tag">{Lotteries}</span>
                    <span class="placeholder-desc">Lista de loterias com vendas e prêmios</span>
                  </div>
                  <div class="placeholder-item">
                    <span class="placeholder-tag">{Ranking}</span>
                    <span class="placeholder-desc">Ranking de vendedores por região (Top 5)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-primary" @click="showPlaceholdersModal = false">
            <i class="fa-solid fa-check"></i>
            Fechar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de Placeholders para Notificações -->
    <div v-if="showNotificationPlaceholdersModal" class="modal-overlay" @click="showNotificationPlaceholdersModal = false">
      <div class="modal-content placeholders-modal" @click.stop>
        <div class="modal-header">
          <h3 class="modal-title">
            <i class="fa-solid fa-info-circle"></i>
            Placeholders Disponíveis - Notificações
          </h3>
          <button class="modal-close" @click="showNotificationPlaceholdersModal = false">
            <i class="fa-solid fa-times"></i>
          </button>
        </div>

        <div class="modal-body">
          <div class="placeholders-info">
            <div class="placeholders-grid">
              <div class="placeholder-group">
                <div 
                  class="placeholder-group-header" 
                  @click="expandedPlaceholderGroups.notificationBasic = !expandedPlaceholderGroups.notificationBasic"
                >
                  <h5 class="placeholder-group-title">📋 Informações Básicas</h5>
                  <i :class="['fa-solid', expandedPlaceholderGroups.notificationBasic ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
                </div>
                <div 
                  v-show="expandedPlaceholderGroups.notificationBasic"
                  class="placeholder-list"
                >
                  <div class="placeholder-item">
                    <span class="placeholder-tag">{LotteryName}</span>
                    <span class="placeholder-desc">Nome da loteria</span>
                  </div>
                  <div class="placeholder-item">
                    <span class="placeholder-tag">{LotteryDetail}</span>
                    <span class="placeholder-desc">Horário/detalhe da loteria</span>
                  </div>
                  <div class="placeholder-item">
                    <span class="placeholder-tag">{Date}</span>
                    <span class="placeholder-desc">Data do resultado</span>
                  </div>
                  <div class="placeholder-item">
                    <span class="placeholder-tag">{Numbers}</span>
                    <span class="placeholder-desc">Números premiados (apenas os que ganharam)</span>
                  </div>
                </div>
              </div>
              <div class="placeholder-group">
                <div 
                  class="placeholder-group-header" 
                  @click="expandedPlaceholderGroups.notificationNumbers = !expandedPlaceholderGroups.notificationNumbers"
                >
                  <h5 class="placeholder-group-title">🏆 Números por Posição</h5>
                  <i :class="['fa-solid', expandedPlaceholderGroups.notificationNumbers ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
                </div>
                <div 
                  v-show="expandedPlaceholderGroups.notificationNumbers"
                  class="placeholder-list"
                >
                  <div class="placeholder-item">
                    <span class="placeholder-tag">{1st}</span>
                    <span class="placeholder-desc">1º número sorteado</span>
                  </div>
                  <div class="placeholder-item">
                    <span class="placeholder-tag">{2nd}</span>
                    <span class="placeholder-desc">2º número sorteado</span>
                  </div>
                  <div class="placeholder-item">
                    <span class="placeholder-tag">{3rd}</span>
                    <span class="placeholder-desc">3º número sorteado</span>
                  </div>
                  <div class="placeholder-item">
                    <span class="placeholder-tag">{4th}</span>
                    <span class="placeholder-desc">4º número sorteado</span>
                  </div>
                  <div class="placeholder-item">
                    <span class="placeholder-tag">{5th}</span>
                    <span class="placeholder-desc">5º número sorteado</span>
                  </div>
                  <div class="placeholder-item">
                    <span class="placeholder-tag">{6th}</span>
                    <span class="placeholder-desc">6º número sorteado</span>
                  </div>
                  <div class="placeholder-item">
                    <span class="placeholder-tag">{7th}</span>
                    <span class="placeholder-desc">7º número sorteado</span>
                  </div>
                </div>
              </div>
              <div class="placeholder-group">
                <div 
                  class="placeholder-group-header" 
                  @click="expandedPlaceholderGroups.notificationPrizes = !expandedPlaceholderGroups.notificationPrizes"
                >
                  <h5 class="placeholder-group-title">💰 Informações de Prêmios</h5>
                  <i :class="['fa-solid', expandedPlaceholderGroups.notificationPrizes ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
                </div>
                <div 
                  v-show="expandedPlaceholderGroups.notificationPrizes"
                  class="placeholder-list"
                >
                  <div class="placeholder-item">
                    <span class="placeholder-tag">{HasPrizes}</span>
                    <span class="placeholder-desc">Sim/Não - se teve prêmios</span>
                  </div>
                  <div class="placeholder-item">
                    <span class="placeholder-tag">{TotalPrize}</span>
                    <span class="placeholder-desc">Valor total dos prêmios</span>
                  </div>
                  <div class="placeholder-item">
                    <span class="placeholder-tag">{PrizeCount}</span>
                    <span class="placeholder-desc">Quantidade de bilhetes premiados</span>
                  </div>
                  <div class="placeholder-item">
                    <span class="placeholder-tag">{PrizeNumbers}</span>
                    <span class="placeholder-desc">Lista de números premiados</span>
                  </div>
                  <div class="placeholder-item">
                    <span class="placeholder-tag">{PrizeDetails}</span>
                    <span class="placeholder-desc">Detalhes completos dos prêmios</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-primary" @click="showNotificationPlaceholdersModal = false">
            <i class="fa-solid fa-check"></i>
            Fechar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de Template de Ranking -->
    <div v-if="editingRankingTemplate" class="modal-overlay" @click="cancelEditRankingTemplate">
      <div class="modal-content ranking-modal" @click.stop>
        <div class="modal-header">
          <h3 class="modal-title">
            <i class="fa-solid fa-trophy"></i>
            Template de Ranking
          </h3>
          <button class="modal-close" @click="cancelEditRankingTemplate">
            <i class="fa-solid fa-times"></i>
          </button>
        </div>

        <div class="modal-body">
          <div class="form-group">
            <label class="form-label">
              <i class="fa-solid fa-file-text"></i>
              Template de Ranking
              <button 
                type="button" 
                class="btn-placeholders" 
                @click="showPlaceholdersModal = true"
                title="Ver placeholders disponíveis"
              >
                <i class="fa-solid fa-info-circle"></i>
                Placeholders
              </button>
            </label>
            <textarea 
              class="form-textarea"
              v-model="currentRankingTemplate.rankingTemplate"
              rows="10"
              placeholder="Digite o template de ranking. Use os mesmos placeholders do relatório diário"
              maxlength="2000"
            ></textarea>
            <small class="form-hint">
              <i class="fa-solid fa-info-circle"></i>
              O template de ranking será anexado ao relatório diário quando enviado.
            </small>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-secondary" @click="cancelEditRankingTemplate">
            <i class="fa-solid fa-times"></i>
            Cancelar
          </button>
          <button type="button" class="btn-primary" @click="saveRankingTemplate()">
            <i class="fa-solid fa-save"></i>
            Salvar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Chat Telegram -->
    <div v-if="editingTelegramChat" class="modal-overlay" @click="cancelTelegramChat">
      <div class="modal-content number-modal" @click.stop>
        <div class="modal-header">
          <h3 class="modal-title">{{ currentTelegramChat.id ? 'Editar Chat' : 'Novo Chat Telegram' }}</h3>
          <button class="modal-close" @click="cancelTelegramChat"><i class="fa-solid fa-times"></i></button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="form-label">Chat ID *</label>
            <input type="text" class="form-input" v-model="currentTelegramChat.chatId" placeholder="-100123... ou ID do usuário" />
            <small class="form-hint">
              Particular: usuário deve abrir o bot e enviar /start antes.
              Grupo: adicione o bot e descubra o ID com @getidsbot.
            </small>
          </div>
          <div class="form-group">
            <label class="form-label">Nome</label>
            <input type="text" class="form-input" v-model="currentTelegramChat.name" placeholder="Nome do chat/grupo" />
          </div>
          <div class="form-group">
            <label class="form-label">Região</label>
            <select class="form-input" v-model="currentTelegramChat.regionId">
              <option :value="null">Todas (Global)</option>
              <option v-for="region in regions" :key="region.id" :value="region.id">{{ region.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label class="form-label">
              <i class="fa-solid fa-robot"></i>
              Receber mensagens do bot
            </label>
            <div class="toggle-container">
              <label class="toggle-switch">
                <input type="checkbox" v-model="currentTelegramChat.receiveResults" />
                <span class="toggle-slider"></span>
              </label>
              <span class="toggle-label">
                {{ currentTelegramChat.receiveResults ? 'Recebe resultados do sorteio' : 'Não recebe resultados' }}
              </span>
            </div>
            <small class="form-hint">
              Ative para este chat receber as notificações de resultado enviadas pelo bot.
              No particular, o usuário precisa ter iniciado o bot (/start) antes.
            </small>
          </div>
          <div class="form-group">
            <label class="form-label">Status do chat</label>
            <div class="toggle-container">
              <label class="toggle-switch">
                <input type="checkbox" v-model="currentTelegramChat.isActive" />
                <span class="toggle-slider"></span>
              </label>
              <span class="toggle-label">{{ currentTelegramChat.isActive ? 'Ativo' : 'Inativo' }}</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn-secondary" @click="cancelTelegramChat">Cancelar</button>
          <button type="button" class="btn-primary" @click="saveTelegramChat">Salvar</button>
        </div>
      </div>
    </div>

    <!-- Modal Template Resultado Telegram -->
    <div v-if="editingTelegramConfig" class="modal-overlay" @click="cancelTelegramConfig">
      <div class="modal-content config-modal" @click.stop>
        <div class="modal-header">
          <h3 class="modal-title">{{ currentTelegramConfig.id ? 'Editar Template Telegram' : 'Novo Template Telegram' }}</h3>
          <button class="modal-close" @click="cancelTelegramConfig"><i class="fa-solid fa-times"></i></button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="form-label">
              Template *
              <button type="button" class="btn-placeholders" @click="showNotificationPlaceholdersModal = true">Placeholders</button>
            </label>
            <textarea class="form-textarea" v-model="currentTelegramConfig.messageTemplate" rows="10" maxlength="2000"></textarea>
          </div>
          <div class="form-group">
            <div class="toggle-container">
              <label class="toggle-switch">
                <input type="checkbox" v-model="currentTelegramConfig.isActive" />
                <span class="toggle-slider"></span>
              </label>
              <span class="toggle-label">{{ currentTelegramConfig.isActive ? 'Ativo' : 'Inativo' }}</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn-secondary" @click="cancelTelegramConfig">Cancelar</button>
          <button type="button" class="btn-primary" @click="saveTelegramConfig">Salvar</button>
        </div>
      </div>
    </div>

    <!-- Modal Template Relatório Telegram -->
    <div v-if="editingTelegramReportTemplate" class="modal-overlay" @click="cancelTelegramReportTemplate">
      <div class="modal-content config-modal" @click.stop>
        <div class="modal-header">
          <h3 class="modal-title">{{ currentTelegramReportTemplate.id ? 'Editar Relatório Telegram' : 'Novo Relatório Telegram' }}</h3>
          <button class="modal-close" @click="cancelTelegramReportTemplate"><i class="fa-solid fa-times"></i></button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="form-label">Nome *</label>
            <input type="text" class="form-input" v-model="currentTelegramReportTemplate.name" />
          </div>
          <div class="form-group">
            <label class="form-label">
              Template diário *
              <button type="button" class="btn-placeholders" @click="showPlaceholdersModal = true">Placeholders</button>
            </label>
            <textarea class="form-textarea" v-model="currentTelegramReportTemplate.dailyReportTemplate" rows="8" maxlength="2000"></textarea>
          </div>
          <div class="form-group">
            <label class="form-label">Template ranking (opcional)</label>
            <textarea class="form-textarea" v-model="currentTelegramReportTemplate.rankingTemplate" rows="5" maxlength="2000"></textarea>
          </div>
          <div class="form-group">
            <div class="toggle-container">
              <label class="toggle-switch">
                <input type="checkbox" v-model="currentTelegramReportTemplate.isActive" />
                <span class="toggle-slider"></span>
              </label>
              <span class="toggle-label">{{ currentTelegramReportTemplate.isActive ? 'Ativo' : 'Inativo' }}</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn-secondary" @click="cancelTelegramReportTemplate">Cancelar</button>
          <button type="button" class="btn-primary" @click="saveTelegramReportTemplate">Salvar</button>
        </div>
      </div>
    </div>

    <!-- Modal Agendamento Telegram -->
    <div v-if="editingTelegramReportSchedule" class="modal-overlay" @click="cancelTelegramReportSchedule">
      <div class="modal-content number-modal" @click.stop>
        <div class="modal-header">
          <h3 class="modal-title">{{ currentTelegramReportSchedule.id ? 'Editar Agendamento' : 'Novo Agendamento Telegram' }}</h3>
          <button class="modal-close" @click="cancelTelegramReportSchedule"><i class="fa-solid fa-times"></i></button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="form-label">Template *</label>
            <select class="form-input" v-model="currentTelegramReportSchedule.templateId">
              <option value="">Selecione</option>
              <option v-for="t in telegramReportTemplates" :key="t.id" :value="t.id">{{ t.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label class="form-label">Chat *</label>
            <select class="form-input" v-model="currentTelegramReportSchedule.chatId">
              <option value="">Selecione</option>
              <option v-for="c in telegramChats" :key="c.id" :value="c.id">{{ c.name || c.chatId }}</option>
            </select>
          </div>
          <div class="form-group">
            <label class="form-label">Região</label>
            <select class="form-input" v-model="currentTelegramReportSchedule.regionId">
              <option :value="null">Todas</option>
              <option v-for="region in regions" :key="region.id" :value="region.id">{{ region.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label class="form-label">Tipo</label>
            <select class="form-input" v-model.number="currentTelegramReportSchedule.scheduleType">
              <option :value="0">Horário fixo</option>
              <option :value="1">Intervalo</option>
            </select>
          </div>
          <div class="form-group" v-if="currentTelegramReportSchedule.scheduleType === 0">
            <label class="form-label">Hora (0-23)</label>
            <input type="number" class="form-input" v-model.number="currentTelegramReportSchedule.fixedHour" min="0" max="23" />
          </div>
          <div class="form-group" v-else>
            <label class="form-label">Intervalo (horas)</label>
            <input type="number" class="form-input" v-model.number="currentTelegramReportSchedule.intervalHours" min="1" />
          </div>
          <div class="form-group">
            <div class="toggle-container">
              <label class="toggle-switch">
                <input type="checkbox" v-model="currentTelegramReportSchedule.isActive" />
                <span class="toggle-slider"></span>
              </label>
              <span class="toggle-label">{{ currentTelegramReportSchedule.isActive ? 'Ativo' : 'Inativo' }}</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn-secondary" @click="cancelTelegramReportSchedule">Cancelar</button>
          <button type="button" class="btn-primary" @click="saveTelegramReportSchedule">Salvar</button>
        </div>
      </div>
    </div>

    <!-- Modal Teste Telegram -->
    <div v-if="showTelegramTestModal" class="modal-overlay" @click="closeTelegramTestModal">
      <div class="modal-content number-modal" @click.stop>
        <div class="modal-header">
          <h3 class="modal-title">
            <i class="fas fa-paper-plane"></i>
            Testar Notificação Telegram
          </h3>
          <button class="modal-close" @click="closeTelegramTestModal"><i class="fa-solid fa-times"></i></button>
        </div>
        <div class="modal-body">
          <div class="info-message" style="margin-bottom: 1rem;">
            <i class="fa-solid fa-info-circle"></i>
            <p>
              Uma mensagem de teste será enviada ao chat selecionado.
              Se aparecer no Telegram, a configuração está correta.
            </p>
          </div>
          <div class="form-group">
            <label class="form-label">Chat de destino *</label>
            <select class="form-input" v-model="telegramTestChatId">
              <option value="">Selecione um chat</option>
              <option v-for="c in telegramChats.filter(x => x.isActive)" :key="c.id" :value="c.id">
                {{ c.name || c.chatId }}
              </option>
            </select>
          </div>
          <div class="form-group" v-if="telegramConfigs.length > 0">
            <label class="form-label">Template (opcional)</label>
            <select class="form-input" v-model="telegramTestConfigId">
              <option :value="null">Template ativo / mensagem padrão</option>
              <option v-for="(c, idx) in telegramConfigs" :key="c.id" :value="c.id">
                Template {{ idx + 1 }}{{ c.isActive ? ' (ativo)' : '' }}
              </option>
            </select>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn-secondary" @click="closeTelegramTestModal">Cancelar</button>
          <button type="button" class="btn-primary" :disabled="!telegramTestChatId || sendingTelegramTest" @click="sendTelegramTest">
            <i :class="sendingTelegramTest ? 'fa-solid fa-spinner fa-spin' : 'fas fa-paper-plane'"></i>
            {{ sendingTelegramTest ? 'Enviando...' : 'Enviar Teste' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Modal editar link do grupo Telegram -->
    <div v-if="editingGroupInviteLink" class="modal-overlay" @click="cancelEditGroupInviteLink">
      <div class="modal-content number-modal" @click.stop>
        <div class="modal-header">
          <h3 class="modal-title">
            <i class="fab fa-telegram"></i>
            Link do grupo Telegram
          </h3>
          <button class="modal-close" @click="cancelEditGroupInviteLink">
            <i class="fa-solid fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="form-label">Link de convite do Telegram</label>
            <input
              type="text"
              class="form-input"
              v-model="groupInviteLinkDraft"
              placeholder="https://t.me/+0W_cxW1tSPw1YTAx"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn-secondary" @click="cancelEditGroupInviteLink">Cancelar</button>
          <button
            type="button"
            class="btn-primary"
            :disabled="savingGroupInviteLink || !groupInviteLinkDraft.trim()"
            @click="saveGroupInviteLink"
          >
            <i :class="savingGroupInviteLink ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-save'"></i>
            {{ savingGroupInviteLink ? 'Salvando...' : 'Salvar' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Modal editar link WhatsApp -->
    <div v-if="editingWhatsAppInviteLink" class="modal-overlay" @click="cancelEditWhatsAppInviteLink">
      <div class="modal-content number-modal" @click.stop>
        <div class="modal-header">
          <h3 class="modal-title">
            <i class="fab fa-whatsapp"></i>
            Link do grupo WhatsApp
          </h3>
          <button class="modal-close" @click="cancelEditWhatsAppInviteLink">
            <i class="fa-solid fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="form-label">Link de convite do WhatsApp</label>
            <input
              type="text"
              class="form-input"
              v-model="whatsAppInviteLinkDraft"
              placeholder="https://chat.whatsapp.com/DclBTtClfLh5atqjj6G7rY"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn-secondary" @click="cancelEditWhatsAppInviteLink">Cancelar</button>
          <button
            type="button"
            class="btn-primary"
            :disabled="savingWhatsAppInviteLink || !whatsAppInviteLinkDraft.trim()"
            @click="saveWhatsAppInviteLink"
          >
            <i :class="savingWhatsAppInviteLink ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-save'"></i>
            {{ savingWhatsAppInviteLink ? 'Salvando...' : 'Salvar' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de Teste de Envio -->
    <div v-if="showTestModal" class="modal-overlay" @click="closeTestModal">
      <div class="modal-content test-modal" @click.stop>
        <div class="modal-header">
          <h3 class="modal-title">
            <i class="fas fa-paper-plane"></i>
            Testar Envio de Mensagem
          </h3>
          <button class="modal-close" @click="closeTestModal">
            <i class="fa-solid fa-times"></i>
          </button>
        </div>

        <div class="modal-body">
          <div class="form-group">
            <label class="form-label">
              <i class="fas fa-phone"></i>
              Selecione o número para receber o teste *
            </label>
            <select 
              class="form-input"
              v-model="testSelectedNumberId"
            >
              <option value="">Selecione um número</option>
              <option 
                v-for="number in activeNumbers" 
                :key="number.id"
                :value="number.id"
              >
                {{ formatDestination(number.phoneNumber) }} 
                <span v-if="number.name">({{ number.name }})</span>
                <span v-if="number.regionName"> - {{ number.regionName }}</span>
              </option>
            </select>
            <small class="form-hint" v-if="activeNumbers.length === 0">
              <i class="fa-solid fa-info-circle"></i>
              Nenhum grupo ou canal ativo. Cadastre um destino primeiro.
            </small>
          </div>

          <div class="test-preview" v-if="testSelectedConfig">
            <p class="preview-label">
              <i class="fa-solid fa-eye"></i>
              Preview da Mensagem:
            </p>
            <div class="preview-content">
              {{ getTestMessagePreview(testSelectedConfig.messageTemplate) }}
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button 
            type="button" 
            class="btn-secondary" 
            @click="closeTestModal"
          >
            <i class="fa-solid fa-times"></i>
            Cancelar
          </button>
          <button 
            type="button" 
            class="btn-primary" 
            @click="sendTestMessage"
            :disabled="!testSelectedNumberId || sendingTest"
          >
            <i v-if="sendingTest" class="fa-solid fa-spinner fa-spin"></i>
            <i v-else class="fa-solid fa-paper-plane"></i>
            {{ sendingTest ? 'Enviando...' : 'Enviar Teste' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mainService from "@/services/mainService";
import { useToast } from "@/composables/useToast";
import { useConfirm } from "@/composables/useConfirm";
import { handleErrorMessage } from "@/services/config";
import jsFunctions from "@/services/jsFunctions";
import { ROLES } from "@/services/permissions";

export default {
  name: "ViewWhatsApp",
  setup() {
    const { success, error, warning, info } = useToast();
    const { confirm } = useConfirm();
    return { 
      toast: { success, error, warning, info },
      confirm 
    };
  },
  data() {
    return {
    loading: true,
    activeChannel: 'whatsapp',
    configs: [],
    numbers: [],
    regions: [],
    activeConfig: null,
    editingConfig: false,
    editingNumber: false,
    numberDestinationType: 'group',
    showWhatsAppGroupTutorial: false,
    currentConfig: {
      id: null,
      messageTemplate: "",
      isActive: true
    },
    currentNumber: {
      id: null,
      phoneNumber: "",
      name: "",
      regionId: null,
      configId: null,
      isActive: true,
      selectedReportTemplateIds: []
    },
    reportTemplates: [],
    reportSchedules: [],
    editingReportTemplate: false,
    editingReportSchedule: false,
    currentReportTemplate: {
      id: null,
      name: "",
      dailyReportTemplate: "",
      rankingTemplate: "",
      isActive: true
    },
    currentReportSchedule: {
      id: null,
      templateId: "",
      numberId: "",
      regionId: null,
      scheduleType: 0,
      fixedHour: null,
      intervalHours: null,
      isActive: true
    },
    showTestModal: false,
    testSelectedConfig: null,
    testSelectedNumberId: "",
    sendingTest: false,
    showPlaceholdersModal: false,
    showNotificationPlaceholdersModal: false,
    editingRankingTemplate: false,
    currentRankingTemplate: {
      id: null,
      rankingTemplate: ""
    },
    expandedPlaceholderGroups: {
      reportBasic: false,
      reportRanking: false,
      notificationBasic: false,
      notificationNumbers: false,
      notificationPrizes: false
    },
    // Telegram
    telegramLoaded: false,
    showTelegramTutorial: true,
    telegramBot: {},
    telegramBotForm: { botToken: '', botUsername: '', groupInviteLink: '', whatsAppInviteLink: '' },
    savingTelegramBot: false,
    telegramChats: [],
    telegramConfigs: [],
    telegramReportTemplates: [],
    telegramReportSchedules: [],
    editingTelegramChat: false,
    currentTelegramChat: {
      id: null,
      chatId: '',
      name: '',
      regionId: null,
      receiveResults: true,
      isActive: true
    },
    editingTelegramConfig: false,
    currentTelegramConfig: {
      id: null,
      messageTemplate: '',
      isActive: true
    },
    editingTelegramReportTemplate: false,
    currentTelegramReportTemplate: {
      id: null,
      name: '',
      dailyReportTemplate: '',
      rankingTemplate: '',
      isActive: true
    },
    editingTelegramReportSchedule: false,
    currentTelegramReportSchedule: {
      id: null,
      templateId: '',
      chatId: '',
      regionId: null,
      scheduleType: 0,
      fixedHour: 8,
      intervalHours: 24,
      isActive: true
    },
    showTelegramTestModal: false,
    telegramTestConfigId: null,
    telegramTestChatId: '',
    sendingTelegramTest: false,
    sendingTelegramTestChatId: null,
    editingGroupInviteLink: false,
    groupInviteLinkDraft: '',
    savingGroupInviteLink: false,
    editingWhatsAppInviteLink: false,
    whatsAppInviteLinkDraft: '',
    savingWhatsAppInviteLink: false
    };
  },
  computed: {
    currentUser() {
      try {
        return JSON.parse(localStorage.getItem('user') || '{}');
      } catch {
        return {};
      }
    },
    isAdmin() {
      return parseInt(this.currentUser?.role) === ROLES.ADMIN;
    },
    isBanca() {
      return parseInt(this.currentUser?.role) === ROLES.BANCA;
    },
    activeNumbers() {
      if (!this.numbers || !Array.isArray(this.numbers)) {
        return [];
      }
      return this.numbers.filter(n => {
        if (!n.isActive) return false;
        const type = this.whatsAppDestinationType(n.phoneNumber);
        return type === 'group' || type === 'channel';
      });
    },
    whatsAppEnabled() {
      return !!(this.activeConfig || (this.configs && this.configs.some(c => c.isActive)));
    },
    telegramEnabled() {
      return !!(this.telegramBot && this.telegramBot.isActive);
    },
    telegramBotUsernameDisplay() {
      const raw = (this.telegramBotForm.botUsername || this.telegramBot.botUsername || '').trim();
      if (!raw) return '';
      return raw.startsWith('@') ? raw : `@${raw}`;
    },
    telegramBotDeepLink() {
      const raw = (this.telegramBotForm.botUsername || this.telegramBot.botUsername || '').trim();
      if (!raw) return '';
      const username = raw.replace(/^@/, '');
      return username ? `https://t.me/${username}` : '';
    },
    telegramGroupInviteLink() {
      const fromForm = (this.telegramBotForm.groupInviteLink || '').trim();
      const fromBot = (this.telegramBot.groupInviteLink || '').trim();
      return fromForm || fromBot || 'https://t.me/+0W_cxW1tSPw1YTAx';
    },
    whatsAppInviteLink() {
      const fromForm = (this.telegramBotForm.whatsAppInviteLink || '').trim();
      const fromBot = (this.telegramBot.whatsAppInviteLink || '').trim();
      return fromForm || fromBot || 'https://chat.whatsapp.com/DclBTtClfLh5atqjj6G7rY';
    },
    destinationTypeFieldLabel() {
      if (this.numberDestinationType === 'group') return 'ID do Grupo *';
      if (this.numberDestinationType === 'channel') return 'ID do Canal *';
      return 'Número de Telefone *';
    },
    destinationTypePlaceholder() {
      if (this.numberDestinationType === 'group') return '1203630...@g.us';
      if (this.numberDestinationType === 'channel') return '1203630...@newsletter';
      return '5511999999999';
    },
    destinationTypeHint() {
      if (this.numberDestinationType === 'group') {
        return 'Cole o JID do grupo terminando em @g.us. A instância precisa estar no grupo.';
      }
      if (this.numberDestinationType === 'channel') {
        return 'Cole o JID do canal terminando em @newsletter. A instância precisa poder publicar no canal.';
      }
      return 'Formato: código do país + DDD + número (ex: 5511999999999)';
    },
    destinationTypeIcon() {
      if (this.numberDestinationType === 'group') return 'fa-solid fa-users';
      if (this.numberDestinationType === 'channel') return 'fa-solid fa-bullhorn';
      return 'fas fa-phone';
    }
  },
  async mounted() {
    this.loading = true;
    if (!this.isAdmin) {
      this.activeChannel = 'whatsapp';
    }
    await this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const tasks = [
          this.loadConfigs(),
          this.loadNumbers(),
          this.loadRegions(),
          this.loadTelegramBot()
        ];
        if (this.isAdmin) {
          tasks.push(
            this.loadReportTemplates(),
            this.loadReportSchedules()
          );
        } else {
          // Não-admin precisa dos templates só para vincular relatórios no número
          tasks.push(this.loadReportTemplates());
        }
        await Promise.all(tasks);
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      } finally {
        this.loading = false;
      }
    },
    async loadConfigs() {
      try {
        const response = await mainService.searchWhatsAppConfigs({});
        this.configs = response.data || [];
        this.activeConfig = this.configs.find(c => c.isActive) || null;
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      }
    },
    async loadNumbers() {
      try {
        const filters = {};
        if (!this.isAdmin && this.currentUser?.id) {
          filters.createdByUserId = this.currentUser.id;
        }
        const response = await mainService.searchWhatsAppNumbers(filters);
        this.numbers = response.data || [];
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      }
    },
    async loadRegions() {
      try {
        const response = await mainService.searchRegions({});
        const allRegions = response.data || [];

        if (this.isAdmin) {
          this.regions = allRegions;
          return;
        }

        if (this.isBanca && this.currentUser?.id) {
          try {
            const bancaResponse = await mainService.getUserBancaId(this.currentUser.id);
            const userBancaId = bancaResponse.data;
            this.regions = userBancaId
              ? allRegions.filter(region => region.bancaId === userBancaId)
              : [];
          } catch {
            this.regions = [];
          }
          return;
        }

        // Gerente / outros: regiões vinculadas + região do usuário
        try {
          const userRegionsResponse = await mainService.getUserRegions(this.currentUser.id);
          const userRegions = userRegionsResponse.data || [];
          const regionIds = userRegions.map(r => r.id);
          if (this.currentUser.regionId && !regionIds.includes(this.currentUser.regionId)) {
            regionIds.push(this.currentUser.regionId);
          }
          this.regions = allRegions.filter(region => regionIds.includes(region.id));
        } catch {
          this.regions = this.currentUser.regionId
            ? allRegions.filter(r => r.id === this.currentUser.regionId)
            : [];
        }
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      }
    },
    createConfig() {
      this.currentConfig = {
        id: null,
        messageTemplate: "🎲 *Resultado da Loteria*\n\n📋 Loteria: {LotteryName}\n⏰ Horário: {LotteryDetail}\n📅 Data: {Date}\n\n🏆 *Números Sorteados:*\n{Numbers}\n\n1º: {1st}\n2º: {2nd}\n3º: {3rd}\n\n💰 *Informações de Prêmios:*\n\nTeve prêmios: {HasPrizes}\nTotal de prêmios: R$ {TotalPrize}\nQuantidade de bilhetes premiados: {PrizeCount}\n\n{PrizeDetails}",
        isActive: true
      };
      this.editingConfig = true;
    },
    editConfig(config) {
      this.currentConfig = {
        id: config.id,
        messageTemplate: config.messageTemplate,
        isActive: config.isActive
      };
      this.editingConfig = true;
    },
    cancelEdit() {
      this.editingConfig = false;
      this.currentConfig = {
        id: null,
        messageTemplate: "",
        isActive: true
      };
    },
    async saveConfig() {
      if (!this.currentConfig.messageTemplate.trim()) {
        this.toast.error("O template da mensagem é obrigatório!");
        return;
      }

      try {
        if (this.currentConfig.id) {
          await mainService.updateWhatsAppConfig(this.currentConfig);
          this.toast.success("Template atualizado com sucesso!");
          
          // Atualizar apenas o item na lista
          const index = this.configs.findIndex(c => c.id === this.currentConfig.id);
          if (index !== -1) {
            this.configs[index] = { ...this.configs[index], ...this.currentConfig };
          }
        } else {
          await mainService.insertWhatsAppConfig(this.currentConfig);
          this.toast.success("Template cadastrado com sucesso!");
          
          // Recarregar apenas os configs para obter o ID gerado
          await this.loadConfigs();
        }
        
        // Atualizar activeConfig se necessário
        this.activeConfig = this.configs.find(c => c.isActive) || null;
        
        this.cancelEdit();
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      }
    },
    async deleteConfig(id) {
      try {
        const confirmed = await this.confirm({
          title: 'Excluir Template',
          message: 'Confirma a exclusão deste template?'
        });

        if (confirmed) {
          try {
            await mainService.deleteWhatsAppConfig(id);
            this.toast.success("Template excluído com sucesso!");
            // Remover apenas o item da lista sem recarregar tudo
            this.configs = this.configs.filter(c => c.id !== id);
            this.activeConfig = this.configs.find(c => c.isActive) || null;
          } catch (error) {
            this.toast.error(handleErrorMessage(error));
          }
        }
      } catch {
        // Usuário cancelou
      }
    },
    createNumber() {
      if (!this.activeConfig) {
        this.toast.error(this.isAdmin
          ? "Você precisa ter um template ativo para cadastrar números!"
          : "Não há template de notificação ativo. Solicite ao administrador.");
        return;
      }
      if (!this.isAdmin && (!this.regions || this.regions.length === 0)) {
        this.toast.error("Nenhuma região disponível para o seu usuário.");
        return;
      }
      this.numberDestinationType = 'group';
      this.currentNumber = {
        id: null,
        phoneNumber: "",
        name: "",
        regionId: this.isAdmin ? null : (this.regions[0]?.id || null),
        configId: this.activeConfig.id,
        isActive: true,
        selectedReportTemplateIds: []
      };
      this.editingNumber = true;
    },
    editNumber(number) {
      const type = this.whatsAppDestinationType(number.phoneNumber);
      this.numberDestinationType = type === 'phone' ? 'group' : type;
      this.currentNumber = {
        id: number.id,
        phoneNumber: type === 'phone' ? '' : number.phoneNumber,
        name: number.name || "",
        regionId: number.regionId,
        configId: number.configId,
        isActive: number.isActive,
        selectedReportTemplateIds: number.selectedReportTemplateIds || []
      };
      this.editingNumber = true;
    },
    cancelEditNumber() {
      this.editingNumber = false;
      this.numberDestinationType = 'group';
      this.currentNumber = {
        id: null,
        phoneNumber: "",
        name: "",
        regionId: null,
        configId: null,
        isActive: true,
        selectedReportTemplateIds: []
      };
    },
    whatsAppDestinationType(value) {
      const v = String(value || '').toLowerCase();
      if (v.includes('@newsletter')) return 'channel';
      if (v.includes('@g.us')) return 'group';
      return 'phone';
    },
    isWhatsAppGroup(value) {
      return this.whatsAppDestinationType(value) === 'group';
    },
    isWhatsAppChannel(value) {
      return this.whatsAppDestinationType(value) === 'channel';
    },
    whatsAppDestinationLabel(value) {
      const type = this.whatsAppDestinationType(value);
      if (type === 'group') return 'Grupo WhatsApp';
      if (type === 'channel') return 'Canal WhatsApp';
      return 'Número individual';
    },
    whatsAppDestinationIcon(value) {
      const type = this.whatsAppDestinationType(value);
      if (type === 'group') return 'fa-solid fa-users';
      if (type === 'channel') return 'fa-solid fa-bullhorn';
      return 'fa-brands fa-whatsapp';
    },
    formatDestination(value) {
      if (!value) return '';
      const type = this.whatsAppDestinationType(value);
      if (type === 'group' || type === 'channel') return value;
      return this.formatPhoneNumber(value);
    },
    normalizeWhatsAppDestination(value, type) {
      let dest = (value || '').trim();
      if (!dest) return '';
      if (type === 'group') {
        dest = dest.replace(/\s/g, '');
        if (!dest.toLowerCase().includes('@g.us')) dest = `${dest}@g.us`;
        return dest;
      }
      if (type === 'channel') {
        dest = dest.replace(/\s/g, '');
        if (!dest.toLowerCase().includes('@newsletter')) dest = `${dest}@newsletter`;
        return dest;
      }
      return dest.replace(/\D/g, '');
    },
    async ensureReportSchedulesForNumber(numberId, regionId, templateIds) {
      if (!templateIds || templateIds.length === 0) return;

      let existingSchedules = this.reportSchedules || [];
      try {
        const response = await mainService.searchWhatsAppReportSchedules({});
        existingSchedules = response.data || [];
        if (this.isAdmin) {
          this.reportSchedules = existingSchedules;
        }
      } catch {
        // segue com o que já temos em memória
      }

      for (const templateId of templateIds) {
        const alreadyExists = existingSchedules.some(
          s => s.numberId === numberId && s.templateId === templateId
        );
        if (alreadyExists) continue;

        try {
          await mainService.insertWhatsAppReportSchedule({
            templateId,
            numberId,
            regionId: regionId || null,
            scheduleType: 0,
            fixedHour: 8,
            intervalHours: null,
            isActive: true
          });
        } catch (error) {
          console.warn('Falha ao criar agendamento automático:', error);
        }
      }
    },
    async saveNumber() {
      if (!this.currentNumber.phoneNumber.trim()) {
        const msg = this.numberDestinationType === 'channel'
          ? "O ID do canal é obrigatório!"
          : "O ID do grupo é obrigatório!";
        this.toast.error(msg);
        return;
      }

      if (this.numberDestinationType !== 'group' && this.numberDestinationType !== 'channel') {
        this.toast.error("Resultados só podem ser enviados para grupo ou canal WhatsApp.");
        return;
      }

      if (!this.currentNumber.configId) {
        this.toast.error("Erro: Template não encontrado!");
        return;
      }

      if (!this.isAdmin && !this.currentNumber.regionId) {
        this.toast.error("Selecione uma região para o destino!");
        return;
      }

      if (!this.isAdmin && this.currentNumber.regionId) {
        const allowed = this.regions.some(r => r.id === this.currentNumber.regionId);
        if (!allowed) {
          this.toast.error("Você só pode cadastrar destinos para as suas regiões.");
          return;
        }
      }

      try {
        const phoneNumber = this.normalizeWhatsAppDestination(
          this.currentNumber.phoneNumber,
          this.numberDestinationType
        );
        if (!phoneNumber.includes('@g.us') && !phoneNumber.includes('@newsletter')) {
          this.toast.error("Informe um grupo (@g.us) ou canal (@newsletter).");
          return;
        }

        const payload = {
          ...this.currentNumber,
          phoneNumber
        };
        if (!this.currentNumber.id && this.currentUser?.id) {
          payload.createdByUserId = this.currentUser.id;
        }

        if (this.currentNumber.id) {
          if (!this.isAdmin && this.currentUser?.id) {
            payload.requestingUserId = this.currentUser.id;
          }
          await mainService.updateWhatsAppNumber(payload);
          this.toast.success("Destino atualizado com sucesso!");
          
          const index = this.numbers.findIndex(n => n.id === this.currentNumber.id);
          if (index !== -1) {
            this.numbers[index] = { ...this.numbers[index], ...payload };
          }

          if (!this.isAdmin) {
            await this.ensureReportSchedulesForNumber(
              this.currentNumber.id,
              this.currentNumber.regionId,
              this.currentNumber.selectedReportTemplateIds || []
            );
          }
        } else {
          const response = await mainService.insertWhatsAppNumber(payload);
          this.toast.success("Destino cadastrado com sucesso!");
          
          await this.loadNumbers();

          const createdId = response?.data?.id;
          if (!this.isAdmin && createdId) {
            await this.ensureReportSchedulesForNumber(
              createdId,
              this.currentNumber.regionId,
              this.currentNumber.selectedReportTemplateIds || []
            );
          }
        }
        
        this.cancelEditNumber();
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      }
    },
    async deleteNumber(id) {
      try {
        const confirmed = await this.confirm({
          title: 'Excluir Número',
          message: 'Confirma a exclusão deste número?'
        });

        if (confirmed) {
          try {
            const requestingUserId = (!this.isAdmin && this.currentUser?.id) ? this.currentUser.id : null;
            await mainService.deleteWhatsAppNumber(id, requestingUserId);
            this.toast.success("Número excluído com sucesso!");
            this.numbers = this.numbers.filter(n => n.id !== id);
          } catch (error) {
            this.toast.error(handleErrorMessage(error));
          }
        }
      } catch {
        // Usuário cancelou
      }
    },
    formatDate(date) {
      return jsFunctions.setDateTimeDisplay(date);
    },
    formatPhoneNumber(phone) {
      if (!phone) return "";
      // Formatar: 5511999999999 -> +55 11 99999-9999
      const cleaned = phone.replace(/\D/g, "");
      if (cleaned.length >= 13) {
        return `+${cleaned.slice(0, 2)} ${cleaned.slice(2, 4)} ${cleaned.slice(4, 9)}-${cleaned.slice(9)}`;
      }
      return phone;
    },
    async loadReportTemplates() {
      try {
        const response = await mainService.searchWhatsAppReportTemplates({});
        this.reportTemplates = response.data || [];
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      }
    },
    async loadReportSchedules() {
      try {
        const response = await mainService.searchWhatsAppReportSchedules({});
        this.reportSchedules = response.data || [];
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      }
    },
    createReportTemplate() {
      this.currentReportTemplate = {
        id: null,
        name: "",
        dailyReportTemplate: "📊 *Relatório de Encerramento*\n\n📅 Data: {Date}\n\n💰 *Resumo Geral:*\nTotal de Vendas: R$ {TotalSales}\nTotal de Prêmios: R$ {TotalPrizes}\n\n🎲 *Loterias:*\n{Lotteries}\n\n🏆 *Ranking de Vendedores:*\n{Ranking}",
        rankingTemplate: "",
        isActive: true
      };
      this.editingReportTemplate = true;
    },
    editReportTemplate(template) {
      this.currentReportTemplate = {
        id: template.id,
        name: template.name,
        dailyReportTemplate: template.dailyReportTemplate,
        rankingTemplate: template.rankingTemplate || "",
        isActive: template.isActive
      };
      this.editingReportTemplate = true;
    },
    editRankingTemplate(template) {
      this.currentRankingTemplate = {
        id: template.id,
        rankingTemplate: template.rankingTemplate || ""
      };
      this.editingRankingTemplate = true;
    },
    cancelEditRankingTemplate() {
      this.editingRankingTemplate = false;
      this.currentRankingTemplate = {
        id: null,
        rankingTemplate: ""
      };
    },
    async saveRankingTemplate() {
      try {
        // Buscar o template completo
        const template = this.reportTemplates.find(t => t.id === this.currentRankingTemplate.id);
        if (!template) {
          this.toast.error("Template não encontrado!");
          return;
        }

        const templateData = {
          ...template,
          rankingTemplate: this.currentRankingTemplate.rankingTemplate
        };

        await mainService.updateWhatsAppReportTemplate(templateData);
        this.toast.success("Template de ranking atualizado com sucesso!");
        
        // Atualizar apenas o item na lista
        const index = this.reportTemplates.findIndex(t => t.id === this.currentRankingTemplate.id);
        if (index !== -1) {
          this.reportTemplates[index] = { ...this.reportTemplates[index], rankingTemplate: this.currentRankingTemplate.rankingTemplate };
        }
        
        this.cancelEditRankingTemplate();
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      }
    },
    cancelEditReportTemplate() {
      this.editingReportTemplate = false;
      this.currentReportTemplate = {
        id: null,
        name: "",
        dailyReportTemplate: "",
        rankingTemplate: "",
        isActive: true
      };
    },
    async saveReportTemplate() {
      if (!this.currentReportTemplate.name.trim()) {
        this.toast.error("O nome do template é obrigatório!");
        return;
      }
      if (!this.currentReportTemplate.dailyReportTemplate.trim()) {
        this.toast.error("O template do relatório diário é obrigatório!");
        return;
      }

      try {
        if (this.currentReportTemplate.id) {
          await mainService.updateWhatsAppReportTemplate(this.currentReportTemplate);
          this.toast.success("Template atualizado com sucesso!");
          
          // Atualizar apenas o item na lista
          const index = this.reportTemplates.findIndex(t => t.id === this.currentReportTemplate.id);
          if (index !== -1) {
            this.reportTemplates[index] = { ...this.reportTemplates[index], ...this.currentReportTemplate };
          }
        } else {
          await mainService.insertWhatsAppReportTemplate(this.currentReportTemplate);
          this.toast.success("Template criado com sucesso!");
          
          // Recarregar apenas os templates para obter o ID gerado
          await this.loadReportTemplates();
        }
        
        this.cancelEditReportTemplate();
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      }
    },
    async deleteReportTemplate(id) {
      try {
        const confirmed = await this.confirm({
          title: 'Excluir Template',
          message: 'Tem certeza que deseja excluir este template?'
        });

        if (confirmed) {
          try {
            await mainService.deleteWhatsAppReportTemplate(id);
            this.toast.success("Template excluído com sucesso!");
            // Remover apenas o item da lista sem recarregar tudo
            this.reportTemplates = this.reportTemplates.filter(t => t.id !== id);
          } catch (error) {
            this.toast.error(handleErrorMessage(error));
          }
        }
      } catch {
        // Usuário cancelou
      }
    },
    createReportSchedule() {
      this.currentReportSchedule = {
        id: null,
        templateId: "",
        numberId: "",
        regionId: null,
        scheduleType: 0,
        fixedHour: 18,
        intervalHours: null,
        isActive: true
      };
      this.editingReportSchedule = true;
    },
    editReportSchedule(schedule) {
      this.currentReportSchedule = {
        id: schedule.id,
        templateId: schedule.templateId,
        numberId: schedule.numberId,
        regionId: schedule.regionId,
        scheduleType: schedule.scheduleType,
        fixedHour: schedule.fixedHour,
        intervalHours: schedule.intervalHours,
        isActive: schedule.isActive
      };
      this.editingReportSchedule = true;
    },
    cancelEditReportSchedule() {
      this.editingReportSchedule = false;
      this.currentReportSchedule = {
        id: null,
        templateId: "",
        numberId: "",
        regionId: null,
        scheduleType: 0,
        fixedHour: null,
        intervalHours: null,
        isActive: true
      };
    },
    async saveReportSchedule() {
      if (!this.currentReportSchedule.templateId) {
        this.toast.error("Selecione um template!");
        return;
      }
      if (!this.currentReportSchedule.numberId) {
        this.toast.error("Selecione um número!");
        return;
      }
      if (this.currentReportSchedule.scheduleType === 0 && (this.currentReportSchedule.fixedHour === null || this.currentReportSchedule.fixedHour < 0 || this.currentReportSchedule.fixedHour > 23)) {
        this.toast.error("Informe um horário válido (0-23)!");
        return;
      }
      if (this.currentReportSchedule.scheduleType === 1 && (this.currentReportSchedule.intervalHours === null || this.currentReportSchedule.intervalHours < 1 || this.currentReportSchedule.intervalHours > 24)) {
        this.toast.error("Informe um intervalo válido (1-24 horas)!");
        return;
      }

      try {
        const scheduleData = {
          ...this.currentReportSchedule,
          regionId: this.currentReportSchedule.regionId || null
        };

        if (this.currentReportSchedule.id) {
          await mainService.updateWhatsAppReportSchedule(scheduleData);
          this.toast.success("Agendamento atualizado com sucesso!");
          
          // Recarregar apenas os agendamentos para obter dados completos (templateName, numberPhone, etc)
          await this.loadReportSchedules();
        } else {
          await mainService.insertWhatsAppReportSchedule(scheduleData);
          this.toast.success("Agendamento criado com sucesso!");
          
          // Recarregar apenas os agendamentos para obter o ID gerado e dados completos
          await this.loadReportSchedules();
        }
        
        this.cancelEditReportSchedule();
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      }
    },
    async deleteReportSchedule(id) {
      try {
        const confirmed = await this.confirm({
          title: 'Excluir Agendamento',
          message: 'Tem certeza que deseja excluir este agendamento?'
        });

        if (confirmed) {
          try {
            await mainService.deleteWhatsAppReportSchedule(id);
            this.toast.success("Agendamento excluído com sucesso!");
            // Remover apenas o item da lista sem recarregar tudo
            this.reportSchedules = this.reportSchedules.filter(s => s.id !== id);
          } catch (error) {
            this.toast.error(handleErrorMessage(error));
          }
        }
      } catch {
        // Usuário cancelou
      }
    },
    openTestModal(config) {
      this.testSelectedConfig = config;
      this.testSelectedNumberId = "";
      this.showTestModal = true;
    },
    closeTestModal() {
      this.showTestModal = false;
      this.testSelectedConfig = null;
      this.testSelectedNumberId = "";
    },
    getTestMessagePreview(template) {
      if (!template) return "";
      
      // Substituir placeholders com dados de exemplo
      return template
        .replace(/{LotteryName}/g, "Loteria Teste")
        .replace(/{LotteryDetail}/g, "12:00")
        .replace(/{Date}/g, new Date().toLocaleDateString('pt-BR'))
        .replace(/{Numbers}/g, "1234 - 5678 - 9012 - 3456 - 7890")
        .replace(/{1st}/g, "1234")
        .replace(/{2nd}/g, "5678")
        .replace(/{3rd}/g, "9012")
        .replace(/{4th}/g, "3456")
        .replace(/{5th}/g, "7890")
        .replace(/{6th}/g, "0000")
        .replace(/{7th}/g, "0000")
        .replace(/{HasPrizes}/g, "Sim")
        .replace(/{TotalPrize}/g, "1500.00")
        .replace(/{PrizeCount}/g, "3")
        .replace(/{PrizeNumbers}/g, "1234, 5678, 9012")
        .replace(/{PrizeDetails}/g, "• 1234 (Grupo): R$ 500.00\n• 5678 (Dezena): R$ 600.00\n• 9012 (Centena): R$ 400.00");
    },
    async sendTestMessage() {
      if (!this.testSelectedNumberId || !this.testSelectedConfig) {
        this.toast.error("Selecione um número para enviar o teste!");
        return;
      }

      this.sendingTest = true;
      try {
        const response = await mainService.testWhatsAppMessage({
          configId: this.testSelectedConfig.id,
          numberId: this.testSelectedNumberId
        });

        if (response.data) {
          this.toast.success("Mensagem de teste enviada com sucesso!");
          this.closeTestModal();
        } else {
          this.toast.error("Erro ao enviar mensagem de teste. Verifique se a instância está conectada.");
        }
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      } finally {
        this.sendingTest = false;
      }
    },

    // ===== Telegram =====
    async loadTelegramData(force = false) {
      if (this.telegramLoaded && !force) return;
      try {
        await Promise.all([
          this.loadTelegramBot(),
          this.loadTelegramChats(),
          this.loadTelegramConfigs(),
          this.loadTelegramReportTemplates(),
          this.loadTelegramReportSchedules()
        ]);
        this.telegramLoaded = true;
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      }
    },
    async loadTelegramBot() {
      try {
        const response = await mainService.searchTelegramBots({});
        const bots = response.data || [];
        this.telegramBot = bots.find(b => b.isActive) || bots[0] || {};
        this.telegramBotForm = {
          botToken: '',
          botUsername: this.telegramBot.botUsername || '',
          groupInviteLink: this.telegramBot.groupInviteLink || 'https://t.me/+0W_cxW1tSPw1YTAx',
          whatsAppInviteLink: this.telegramBot.whatsAppInviteLink || 'https://chat.whatsapp.com/DclBTtClfLh5atqjj6G7rY'
        };
      } catch (error) {
        this.telegramBot = {};
        this.telegramBotForm = {
          botToken: '',
          botUsername: '',
          groupInviteLink: 'https://t.me/+0W_cxW1tSPw1YTAx',
          whatsAppInviteLink: 'https://chat.whatsapp.com/DclBTtClfLh5atqjj6G7rY'
        };
      }
    },
    openEditGroupInviteLink() {
      this.groupInviteLinkDraft = this.telegramGroupInviteLink || 'https://t.me/+0W_cxW1tSPw1YTAx';
      this.editingGroupInviteLink = true;
    },
    cancelEditGroupInviteLink() {
      this.editingGroupInviteLink = false;
      this.groupInviteLinkDraft = '';
    },
    async saveGroupInviteLink() {
      const link = (this.groupInviteLinkDraft || '').trim();
      if (!link) {
        this.toast.error('Informe o link do grupo Telegram.');
        return;
      }
      if (!this.telegramBot.id) {
        this.toast.error('Cadastre o bot Telegram antes de salvar o link.');
        return;
      }

      this.savingGroupInviteLink = true;
      try {
        await mainService.updateTelegramBot({
          id: this.telegramBot.id,
          botToken: this.telegramBot.botToken || '',
          botUsername: this.telegramBot.botUsername || this.telegramBotForm.botUsername || null,
          groupInviteLink: link,
          whatsAppInviteLink: this.telegramBotForm.whatsAppInviteLink || this.telegramBot.whatsAppInviteLink || null,
          isActive: this.telegramBot.isActive !== false
        });
        this.telegramBot = { ...this.telegramBot, groupInviteLink: link };
        this.telegramBotForm.groupInviteLink = link;
        this.toast.success('Link do Telegram atualizado!');
        this.cancelEditGroupInviteLink();
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      } finally {
        this.savingGroupInviteLink = false;
      }
    },
    openEditWhatsAppInviteLink() {
      this.whatsAppInviteLinkDraft = this.whatsAppInviteLink || 'https://chat.whatsapp.com/DclBTtClfLh5atqjj6G7rY';
      this.editingWhatsAppInviteLink = true;
    },
    cancelEditWhatsAppInviteLink() {
      this.editingWhatsAppInviteLink = false;
      this.whatsAppInviteLinkDraft = '';
    },
    async saveWhatsAppInviteLink() {
      const link = (this.whatsAppInviteLinkDraft || '').trim();
      if (!link) {
        this.toast.error('Informe o link do grupo WhatsApp.');
        return;
      }
      if (!this.telegramBot.id) {
        this.toast.error('Cadastre o bot Telegram antes (os links de convite ficam na config de notificações).');
        return;
      }

      this.savingWhatsAppInviteLink = true;
      try {
        await mainService.updateTelegramBot({
          id: this.telegramBot.id,
          botToken: this.telegramBot.botToken || '',
          botUsername: this.telegramBot.botUsername || this.telegramBotForm.botUsername || null,
          groupInviteLink: this.telegramBotForm.groupInviteLink || this.telegramBot.groupInviteLink || null,
          whatsAppInviteLink: link,
          isActive: this.telegramBot.isActive !== false
        });
        this.telegramBot = { ...this.telegramBot, whatsAppInviteLink: link };
        this.telegramBotForm.whatsAppInviteLink = link;
        this.toast.success('Link do WhatsApp atualizado!');
        this.cancelEditWhatsAppInviteLink();
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      } finally {
        this.savingWhatsAppInviteLink = false;
      }
    },
    async saveTelegramBot() {
      const hasNewToken = !!(this.telegramBotForm.botToken && this.telegramBotForm.botToken.trim());
      if (!this.telegramBot.id && !hasNewToken) {
        this.toast.error('Informe o token do bot!');
        return;
      }
      this.savingTelegramBot = true;
      try {
        if (this.telegramBot.id) {
          await mainService.updateTelegramBot({
            id: this.telegramBot.id,
            botToken: hasNewToken ? this.telegramBotForm.botToken.trim() : (this.telegramBot.botToken || ''),
            botUsername: this.telegramBotForm.botUsername || null,
            groupInviteLink: this.telegramBotForm.groupInviteLink || null,
            whatsAppInviteLink: this.telegramBotForm.whatsAppInviteLink || null,
            isActive: this.telegramBot.isActive !== false
          });
          this.toast.success('Bot Telegram atualizado!');
        } else {
          await mainService.insertTelegramBot({
            botToken: this.telegramBotForm.botToken.trim(),
            botUsername: this.telegramBotForm.botUsername || null,
            groupInviteLink: this.telegramBotForm.groupInviteLink || null,
            whatsAppInviteLink: this.telegramBotForm.whatsAppInviteLink || null,
            isActive: true
          });
          this.toast.success('Bot Telegram cadastrado e ativado!');
        }
        this.telegramBotForm.botToken = '';
        await this.loadTelegramBot();
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      } finally {
        this.savingTelegramBot = false;
      }
    },
    async toggleTelegramEnabled(enabled) {
      if (!this.telegramBot.id) {
        if (enabled && this.telegramBotForm.botToken) {
          await this.saveTelegramBot();
          return;
        }
        this.toast.warning('Cadastre o bot antes de ativar.');
        return;
      }
      try {
        await mainService.updateTelegramBot({
          id: this.telegramBot.id,
          botToken: this.telegramBot.botToken || '',
          botUsername: this.telegramBot.botUsername || null,
          groupInviteLink: this.telegramBotForm.groupInviteLink || this.telegramBot.groupInviteLink || null,
          whatsAppInviteLink: this.telegramBotForm.whatsAppInviteLink || this.telegramBot.whatsAppInviteLink || null,
          isActive: !!enabled
        });
        this.telegramBot = { ...this.telegramBot, isActive: !!enabled };
        this.toast.success(enabled ? 'Telegram ativado para notificações' : 'Telegram desativado');
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
        await this.loadTelegramBot();
      }
    },
    async loadTelegramChats() {
      try {
        const response = await mainService.searchTelegramChats({});
        this.telegramChats = response.data || [];
      } catch {
        this.telegramChats = [];
      }
    },
    createTelegramChat() {
      this.currentTelegramChat = {
        id: null, chatId: '', name: '', regionId: null, receiveResults: true, isActive: true
      };
      this.editingTelegramChat = true;
    },
    editTelegramChat(chat) {
      this.currentTelegramChat = {
        id: chat.id,
        chatId: chat.chatId,
        name: chat.name || '',
        regionId: chat.regionId || null,
        receiveResults: chat.receiveResults !== false,
        isActive: chat.isActive
      };
      this.editingTelegramChat = true;
    },
    cancelTelegramChat() {
      this.editingTelegramChat = false;
    },
    async saveTelegramChat() {
      if (!this.currentTelegramChat.chatId) {
        this.toast.error('Informe o Chat ID!');
        return;
      }
      try {
        if (this.currentTelegramChat.id) {
          await mainService.updateTelegramChat(this.currentTelegramChat);
          this.toast.success('Chat atualizado!');
        } else {
          await mainService.insertTelegramChat(this.currentTelegramChat);
          this.toast.success('Chat cadastrado!');
        }
        this.cancelTelegramChat();
        await this.loadTelegramChats();
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      }
    },
    async deleteTelegramChat(id) {
      const confirmed = await this.confirm({ title: 'Excluir Chat', message: 'Confirma a exclusão deste chat?' });
      if (!confirmed) return;
      try {
        await mainService.deleteTelegramChat(id);
        this.telegramChats = this.telegramChats.filter(c => c.id !== id);
        this.toast.success('Chat excluído!');
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      }
    },
    async loadTelegramConfigs() {
      try {
        const response = await mainService.searchTelegramConfigs({});
        this.telegramConfigs = response.data || [];
      } catch {
        this.telegramConfigs = [];
      }
    },
    createTelegramConfig() {
      this.currentTelegramConfig = {
        id: null,
        isActive: true,
        messageTemplate: "🎲 Resultado da Loteria\n\n📋 Loteria: {LotteryName}\n⏰ Horário: {LotteryDetail}\n📅 Data: {Date}\n\n🏆 Números Sorteados:\n{Numbers}\n\n1º: {1st}\n2º: {2nd}\n3º: {3rd}\n\n💰 Informações de Prêmios:\nTeve prêmios: {HasPrizes}\nTotal: R$ {TotalPrize}\nBilhetes: {PrizeCount}\n\n{PrizeDetails}"
      };
      this.editingTelegramConfig = true;
    },
    editTelegramConfig(config) {
      this.currentTelegramConfig = {
        id: config.id,
        messageTemplate: config.messageTemplate,
        isActive: config.isActive
      };
      this.editingTelegramConfig = true;
    },
    cancelTelegramConfig() {
      this.editingTelegramConfig = false;
    },
    async saveTelegramConfig() {
      if (!this.currentTelegramConfig.messageTemplate?.trim()) {
        this.toast.error('Template obrigatório!');
        return;
      }
      try {
        if (this.currentTelegramConfig.id) {
          await mainService.updateTelegramConfig(this.currentTelegramConfig);
          this.toast.success('Template atualizado!');
        } else {
          await mainService.insertTelegramConfig(this.currentTelegramConfig);
          this.toast.success('Template cadastrado!');
        }
        this.cancelTelegramConfig();
        await this.loadTelegramConfigs();
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      }
    },
    async deleteTelegramConfig(id) {
      const confirmed = await this.confirm({ title: 'Excluir Template', message: 'Confirma a exclusão?' });
      if (!confirmed) return;
      try {
        await mainService.deleteTelegramConfig(id);
        this.telegramConfigs = this.telegramConfigs.filter(c => c.id !== id);
        this.toast.success('Template excluído!');
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      }
    },
    openTelegramTestModal(config) {
      this.telegramTestConfigId = config?.id || null;
      this.telegramTestChatId = '';
      this.showTelegramTestModal = true;
    },
    closeTelegramTestModal() {
      this.showTelegramTestModal = false;
      this.telegramTestConfigId = null;
      this.telegramTestChatId = '';
    },
    async sendTelegramTestToChat(chat) {
      if (!chat?.id) return;
      if (!this.telegramEnabled) {
        this.toast.error('Ative o bot Telegram antes de testar.');
        return;
      }
      if (!chat.isActive) {
        this.toast.error('Ative o chat antes de testar.');
        return;
      }

      this.sendingTelegramTestChatId = chat.id;
      try {
        const activeConfig = this.telegramConfigs.find(c => c.isActive);
        const response = await mainService.testTelegramMessage({
          configId: activeConfig?.id || null,
          chatId: chat.id
        });
        if (response.data) {
          this.toast.success(`Teste enviado para ${chat.name || chat.chatId}. Confira no Telegram.`);
        } else {
          this.toast.error('Falha ao enviar. Verifique bot ativo, Chat ID e se o usuário deu /start (ou o bot está no grupo).');
        }
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      } finally {
        this.sendingTelegramTestChatId = null;
      }
    },
    async sendTelegramTest() {
      if (!this.telegramTestChatId) {
        this.toast.error('Selecione um chat!');
        return;
      }
      if (!this.telegramEnabled) {
        this.toast.error('Ative o bot Telegram antes de testar.');
        return;
      }
      this.sendingTelegramTest = true;
      try {
        const response = await mainService.testTelegramMessage({
          configId: this.telegramTestConfigId || null,
          chatId: this.telegramTestChatId
        });
        if (response.data) {
          this.toast.success('Teste enviado! Abra o Telegram e confira se a mensagem chegou.');
          this.closeTelegramTestModal();
        } else {
          this.toast.error('Falha ao enviar. Verifique bot, chat e se o bot está no grupo / usuário deu /start.');
        }
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      } finally {
        this.sendingTelegramTest = false;
      }
    },
    async loadTelegramReportTemplates() {
      try {
        const response = await mainService.searchTelegramReportTemplates({});
        this.telegramReportTemplates = response.data || [];
      } catch {
        this.telegramReportTemplates = [];
      }
    },
    createTelegramReportTemplate() {
      this.currentTelegramReportTemplate = {
        id: null,
        name: 'Encerramento',
        dailyReportTemplate: "📊 Relatório de Encerramento\n📅 Data: {Date}\nTotal de Vendas: R$ {TotalSales}\nTotal de Prêmios: R$ {TotalPrizes}\nBanca Recebeu: R$ {BancaRecebeu}\nBanca Pagou: R$ {BancaPagou}\n\n🎲 Loterias:\n{Lotteries}\n\n🏆 Ranking:\n{Ranking}",
        rankingTemplate: '',
        isActive: true
      };
      this.editingTelegramReportTemplate = true;
    },
    editTelegramReportTemplate(template) {
      this.currentTelegramReportTemplate = {
        id: template.id,
        name: template.name,
        dailyReportTemplate: template.dailyReportTemplate,
        rankingTemplate: template.rankingTemplate || '',
        isActive: template.isActive
      };
      this.editingTelegramReportTemplate = true;
    },
    cancelTelegramReportTemplate() {
      this.editingTelegramReportTemplate = false;
    },
    async saveTelegramReportTemplate() {
      if (!this.currentTelegramReportTemplate.name?.trim() || !this.currentTelegramReportTemplate.dailyReportTemplate?.trim()) {
        this.toast.error('Nome e template são obrigatórios!');
        return;
      }
      try {
        if (this.currentTelegramReportTemplate.id) {
          await mainService.updateTelegramReportTemplate(this.currentTelegramReportTemplate);
        } else {
          await mainService.insertTelegramReportTemplate(this.currentTelegramReportTemplate);
        }
        this.toast.success('Template de fechamento salvo!');
        this.cancelTelegramReportTemplate();
        await this.loadTelegramReportTemplates();
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      }
    },
    async deleteTelegramReportTemplate(id) {
      const confirmed = await this.confirm({ title: 'Excluir', message: 'Excluir template de fechamento?' });
      if (!confirmed) return;
      try {
        await mainService.deleteTelegramReportTemplate(id);
        this.telegramReportTemplates = this.telegramReportTemplates.filter(t => t.id !== id);
        this.toast.success('Excluído!');
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      }
    },
    async loadTelegramReportSchedules() {
      try {
        const response = await mainService.searchTelegramReportSchedules({});
        this.telegramReportSchedules = response.data || [];
      } catch {
        this.telegramReportSchedules = [];
      }
    },
    createTelegramReportSchedule() {
      this.currentTelegramReportSchedule = {
        id: null,
        templateId: '',
        chatId: '',
        regionId: null,
        scheduleType: 0,
        fixedHour: 8,
        intervalHours: 24,
        isActive: true
      };
      this.editingTelegramReportSchedule = true;
    },
    editTelegramReportSchedule(schedule) {
      this.currentTelegramReportSchedule = {
        id: schedule.id,
        templateId: schedule.templateId,
        chatId: schedule.chatId,
        regionId: schedule.regionId || null,
        scheduleType: schedule.scheduleType,
        fixedHour: schedule.fixedHour,
        intervalHours: schedule.intervalHours,
        isActive: schedule.isActive
      };
      this.editingTelegramReportSchedule = true;
    },
    cancelTelegramReportSchedule() {
      this.editingTelegramReportSchedule = false;
    },
    async saveTelegramReportSchedule() {
      if (!this.currentTelegramReportSchedule.templateId || !this.currentTelegramReportSchedule.chatId) {
        this.toast.error('Selecione template e chat!');
        return;
      }
      try {
        if (this.currentTelegramReportSchedule.id) {
          await mainService.updateTelegramReportSchedule(this.currentTelegramReportSchedule);
        } else {
          await mainService.insertTelegramReportSchedule(this.currentTelegramReportSchedule);
        }
        this.toast.success('Agendamento salvo!');
        this.cancelTelegramReportSchedule();
        await this.loadTelegramReportSchedules();
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      }
    },
    async deleteTelegramReportSchedule(id) {
      const confirmed = await this.confirm({ title: 'Excluir', message: 'Excluir agendamento?' });
      if (!confirmed) return;
      try {
        await mainService.deleteTelegramReportSchedule(id);
        this.telegramReportSchedules = this.telegramReportSchedules.filter(s => s.id !== id);
        this.toast.success('Excluído!');
      } catch (error) {
        this.toast.error(handleErrorMessage(error));
      }
    }
  }
};
</script>

<style scoped>
.whatsapp-page {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
  min-height: 100vh;
}

.header {
  margin-bottom: 30px;
}

.header h1 {
  font-size: 2rem;
  color: var(--text-primary);
  margin: 0 0 10px 0;
  align-items: center;
  gap: 15px;
}

.header h1 i {
  color: #f0ad4e;
}

.subtitle {
  color: var(--text-secondary);
  margin: 0;
}

.channel-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.channel-tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--border-color, #ddd);
  background: var(--card-bg, #fff);
  color: var(--text-primary);
  border-radius: 999px;
  padding: 10px 16px;
  cursor: pointer;
  font-weight: 600;
}

.channel-tab.active {
  border-color: #0088cc;
  box-shadow: 0 0 0 2px rgba(0, 136, 204, 0.15);
}

.channel-tab .fa-whatsapp { color: #25D366; }
.channel-tab .fa-telegram { color: #0088cc; }

.channel-status-pill {
  font-size: 11px;
  border-radius: 999px;
  padding: 2px 8px;
  font-weight: 700;
}

.channel-status-pill.on {
  background: rgba(37, 211, 102, 0.15);
  color: #128c7e;
}

.channel-status-pill.off {
  background: rgba(220, 53, 69, 0.12);
  color: #c0392b;
}

.telegram-tutorial {
  padding: 0 4px 8px;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  text-align: left;
}

.tutorial-block {
  text-align: left;
}

.tutorial-block h4 {
  margin: 0 0 0.5rem;
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 8px;
}

.tutorial-block ol {
  margin: 0;
  padding-left: 1.25rem;
  line-height: 1.55;
  color: var(--text-secondary, #555);
  text-align: left;
  list-style-position: outside;
}

.tutorial-block li {
  text-align: left;
}

.tutorial-block li + li {
  margin-top: 0.35rem;
}

.tutorial-block code {
  background: rgba(0, 0, 0, 0.06);
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 0.9em;
}

.tutorial-note {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 12px 14px;
  border-radius: 8px;
  background: rgba(0, 136, 204, 0.08);
  border: 1px solid rgba(0, 136, 204, 0.2);
}

.tutorial-note i {
  color: #0088cc;
  margin-top: 2px;
}

.tutorial-note p {
  margin: 0;
  line-height: 1.45;
  color: var(--text-secondary, #555);
  text-align: left;
}

.header-toggle {
  margin-left: auto;
}

.telegram-bot-form {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 16px;
  align-items: end;
}

.telegram-group-link-field {
  grid-column: 1 / -1;
}

.results-invite-wrap {
  margin-bottom: 1.5rem;
}

.results-invite-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.results-invite-tile {
  position: relative;
  display: block;
  text-decoration: none;
  color: inherit;
  border-radius: 18px;
  overflow: hidden;
  isolation: isolate;
  min-height: 92px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
}

.results-invite-tile.whatsapp {
  background:
    linear-gradient(135deg, rgba(37, 211, 102, 0.22) 0%, rgba(18, 140, 126, 0.08) 48%, rgba(15, 23, 42, 0.35) 100%);
  border-color: rgba(37, 211, 102, 0.28);
  box-shadow: 0 10px 28px rgba(18, 140, 126, 0.12);
}

.results-invite-tile.telegram {
  background:
    linear-gradient(135deg, rgba(0, 136, 204, 0.24) 0%, rgba(34, 158, 217, 0.08) 48%, rgba(15, 23, 42, 0.35) 100%);
  border-color: rgba(0, 136, 204, 0.28);
  box-shadow: 0 10px 28px rgba(0, 136, 204, 0.12);
}

.results-invite-tile-glow {
  position: absolute;
  inset: -40% auto auto -20%;
  width: 180px;
  height: 180px;
  border-radius: 50%;
  filter: blur(40px);
  opacity: 0.55;
  pointer-events: none;
  z-index: 0;
}

.results-invite-tile.whatsapp .results-invite-tile-glow {
  background: radial-gradient(circle, rgba(37, 211, 102, 0.55), transparent 68%);
}

.results-invite-tile.telegram .results-invite-tile-glow {
  background: radial-gradient(circle, rgba(0, 168, 255, 0.5), transparent 68%);
}

.results-invite-tile-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 18px 18px 16px;
  height: 100%;
}

.results-invite-badge {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  font-size: 1.55rem;
  color: #fff;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.25);
}

.results-invite-tile.whatsapp .results-invite-badge {
  background: linear-gradient(160deg, #3fe07a 0%, #1fa855 55%, #128c7e 100%);
}

.results-invite-tile.telegram .results-invite-badge {
  background: linear-gradient(160deg, #3db4f5 0%, #0088cc 55%, #006699 100%);
}

.results-invite-copy {
  min-width: 0;
  flex: 1;
}

.results-invite-copy strong {
  display: block;
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: var(--text-primary, #f3f4f6);
}

.results-invite-copy span {
  display: block;
  margin-top: 2px;
  font-size: 0.86rem;
  color: var(--text-secondary, #9ca3af);
}

.results-invite-cta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  padding: 10px 14px;
  border-radius: 999px;
  font-size: 0.88rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.02em;
  transition: transform 0.2s ease, background 0.2s ease;
}

.results-invite-tile.whatsapp .results-invite-cta {
  background: rgba(37, 211, 102, 0.95);
  box-shadow: 0 6px 16px rgba(18, 140, 126, 0.28);
}

.results-invite-tile.telegram .results-invite-cta {
  background: rgba(0, 136, 204, 0.95);
  box-shadow: 0 6px 16px rgba(0, 136, 204, 0.28);
}

.results-invite-cta i {
  font-size: 0.75rem;
  transition: transform 0.2s ease;
}

.results-invite-tile:hover {
  transform: translateY(-2px);
}

.results-invite-tile.whatsapp:hover {
  border-color: rgba(37, 211, 102, 0.5);
  box-shadow: 0 14px 34px rgba(18, 140, 126, 0.2);
}

.results-invite-tile.telegram:hover {
  border-color: rgba(0, 136, 204, 0.5);
  box-shadow: 0 14px 34px rgba(0, 136, 204, 0.2);
}

.results-invite-tile:hover .results-invite-cta {
  transform: scale(1.03);
}

.results-invite-tile:hover .results-invite-cta i {
  transform: translateX(3px);
}

.results-invite-edit {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  width: 32px;
  height: 32px;
  border: 1px solid color-mix(in srgb, var(--accent-color, #3b82f6) 35%, transparent);
  border-radius: 10px;
  display: grid;
  place-items: center;
  cursor: pointer;
  color: var(--accent-color, #3b82f6);
  background: color-mix(in srgb, var(--accent-color, #3b82f6) 12%, var(--card-bg, #fff));
  backdrop-filter: blur(8px);
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}

.results-invite-edit:hover {
  color: #fff;
  border-color: var(--accent-color, #3b82f6);
  background: var(--accent-color, #3b82f6);
  transform: scale(1.05);
}

[data-theme="dark"] .results-invite-edit {
  color: #93c5fd;
  border-color: rgba(147, 197, 253, 0.35);
  background: rgba(59, 130, 246, 0.2);
}

[data-theme="dark"] .results-invite-edit:hover {
  color: #0f172a;
  border-color: #93c5fd;
  background: #93c5fd;
}

.results-invite-tile.empty {
  opacity: 0.85;
  border-style: dashed;
}

@media (max-width: 768px) {
  .results-invite-grid {
    grid-template-columns: 1fr;
  }

  .results-invite-tile-content {
    padding: 16px;
  }

  .results-invite-cta {
    padding: 9px 12px;
  }
}

.destination-type-toggle {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.destination-type-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--border-color, #ddd);
  background: var(--card-bg, #fff);
  color: var(--text-primary);
  border-radius: 8px;
  padding: 10px 14px;
  cursor: pointer;
  font-weight: 600;
}

.destination-type-btn.active {
  border-color: #25D366;
  box-shadow: 0 0 0 2px rgba(37, 211, 102, 0.18);
  color: #128c7e;
}

.whatsapp-group-tutorial {
  margin-bottom: 1rem;
}

.form-actions-inline {
  display: flex;
  align-items: end;
}

@media (max-width: 900px) {
  .telegram-bot-form {
    grid-template-columns: 1fr;
  }
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3rem;
}

.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  color: var(--text-muted);
}

.card {
  background: var(--card-bg);
  border-radius: 12px;
  padding: 30px;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--card-border);
  margin-bottom: 25px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.card-header h2 {
  font-size: 1.4rem;
  color: var(--text-primary);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.templates-list,
.numbers-list {
  display: flex;
  gap: 1rem;
}

.template-card,
.number-card {
  background: var(--bg-secondary);
  border-radius: 8px;
  padding: 1.5rem;
  border: 2px solid var(--border-color);
  transition: var(--transition);
}

.template-card.active,
.number-card.active {
  border-color: #25D366;
  background: rgba(37, 211, 102, 0.1);
}

[data-theme="dark"] .template-card.active,
[data-theme="dark"] .number-card.active {
  background: rgba(37, 211, 102, 0.15);
}

.template-header,
.number-info {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.template-info {
  flex: 1;
}

.template-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 0.25rem 0;
}

.active-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  background: #25D366;
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
}

.template-date {
  font-size: 0.875rem;
  color: var(--text-muted);
  margin: 0;
  text-align: left;
}

.template-actions,
.number-actions,
.schedule-actions {
  display: flex;
  gap: 0.45rem;
  align-items: center;
}

.btn-action {
  --btn-action-size: 36px;
  width: var(--btn-action-size);
  height: var(--btn-action-size);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-radius: 10px;
  border: 1px solid var(--card-border, var(--border-color, rgba(0, 0, 0, 0.1)));
  background: var(--bg-secondary, rgba(0, 0, 0, 0.04));
  color: var(--text-secondary, #6b7280);
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

.btn-action:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.btn-action:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.btn-action.btn-edit {
  color: var(--accent-color, #3b82f6);
  border-color: color-mix(in srgb, var(--accent-color, #3b82f6) 35%, transparent);
  background: color-mix(in srgb, var(--accent-color, #3b82f6) 10%, transparent);
}

.btn-action.btn-edit:hover {
  color: #fff;
  border-color: var(--accent-color, #3b82f6);
  background: var(--accent-color, #3b82f6);
}

.btn-action.btn-delete {
  color: var(--danger, #ef4444);
  border-color: color-mix(in srgb, var(--danger, #ef4444) 35%, transparent);
  background: color-mix(in srgb, var(--danger, #ef4444) 10%, transparent);
}

.btn-action.btn-delete:hover {
  color: #fff;
  border-color: var(--danger, #ef4444);
  background: var(--danger, #ef4444);
}

.btn-action.btn-test {
  color: #16a34a;
  border-color: rgba(22, 163, 74, 0.35);
  background: rgba(22, 163, 74, 0.1);
}

.btn-action.btn-test:hover {
  color: #fff;
  border-color: #16a34a;
  background: #16a34a;
}

.btn-action.btn-ranking {
  color: #d97706;
  border-color: rgba(217, 119, 6, 0.35);
  background: rgba(217, 119, 6, 0.1);
}

.btn-action.btn-ranking:hover {
  color: #fff;
  border-color: #d97706;
  background: #d97706;
}

[data-theme="dark"] .btn-action {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.22);
  color: #e5e7eb;
  box-shadow: none;
}

[data-theme="dark"] .btn-action:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.35);
}

[data-theme="dark"] .btn-action.btn-edit {
  color: #dbeafe;
  border-color: #60a5fa;
  background: rgba(37, 99, 235, 0.45);
}

[data-theme="dark"] .btn-action.btn-edit i {
  color: #dbeafe;
}

[data-theme="dark"] .btn-action.btn-edit:hover {
  color: #fff;
  border-color: #93c5fd;
  background: #2563eb;
}

[data-theme="dark"] .btn-action.btn-edit:hover i {
  color: #fff;
}

[data-theme="dark"] .btn-action.btn-delete {
  color: #fee2e2;
  border-color: #f87171;
  background: rgba(220, 38, 38, 0.45);
}

[data-theme="dark"] .btn-action.btn-delete i {
  color: #fee2e2;
}

[data-theme="dark"] .btn-action.btn-delete:hover {
  color: #fff;
  border-color: #fca5a5;
  background: #dc2626;
}

[data-theme="dark"] .btn-action.btn-delete:hover i {
  color: #fff;
}

[data-theme="dark"] .btn-action.btn-test {
  color: #dcfce7;
  border-color: #4ade80;
  background: rgba(22, 163, 74, 0.45);
}

[data-theme="dark"] .btn-action.btn-test i {
  color: #dcfce7;
}

[data-theme="dark"] .btn-action.btn-test:hover {
  color: #fff;
  border-color: #86efac;
  background: #16a34a;
}

[data-theme="dark"] .btn-action.btn-test:hover i {
  color: #fff;
}

[data-theme="dark"] .btn-action.btn-ranking {
  color: #fef3c7;
  border-color: #fbbf24;
  background: rgba(217, 119, 6, 0.45);
}

[data-theme="dark"] .btn-action.btn-ranking i {
  color: #fef3c7;
}

[data-theme="dark"] .btn-action.btn-ranking:hover {
  color: #fff;
  border-color: #fcd34d;
  background: #d97706;
}

[data-theme="dark"] .btn-action.btn-ranking:hover i {
  color: #fff;
}

.template-preview {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border-color);
}

.preview-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-secondary);
  margin: 0 0 0.5rem 0;
}

.preview-content {
  background: var(--input-background);
  padding: 1rem;
  border-radius: 6px;
  border: 1px solid var(--border-color);
  white-space: pre-wrap;
  font-family: 'Courier New', monospace;
  font-size: 0.875rem;
  color: var(--text-primary);
}

.number-main {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  flex: 1;
}

.number-main i {
  font-size: 1.5rem;
  color: #25D366;
  margin-top: 0.25rem;
}

.number-details {
  flex: 1;
}

.number-phone {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 0.25rem 0;
}

.number-name {
  font-size: 0.875rem;
  color: var(--text-secondary);
  margin: 0 0 0.25rem 0;
}

.number-region {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.875rem;
  color: var(--text-muted);
  margin: 0;
}

.number-status {
  display: flex;
  align-items: center;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
}

.badge-success {
  background: rgba(16, 185, 129, 0.2);
  color: var(--success);
}

.badge-danger {
  background: rgba(239, 68, 68, 0.2);
  color: var(--danger);
}

[data-theme="dark"] .badge-success {
  background: rgba(16, 185, 129, 0.25);
}

[data-theme="dark"] .badge-danger {
  background: rgba(239, 68, 68, 0.25);
}

.empty-state {
  text-align: center;
  padding: 3rem;
  color: var(--text-muted);
}

.empty-state i {
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.config-modal,
.number-modal,
.report-template-modal,
.schedule-modal {
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
}

.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.form-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.btn-close {
  background: none;
  border: none;
  font-size: 1.25rem;
  color: var(--text-muted);
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  transition: all 0.2s;
}

.btn-close:hover {
  background: var(--bg-primary);
  color: var(--text-primary);
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
}

.form-input,
.form-textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  font-size: 1rem;
  transition: var(--transition);
  background: var(--input-background);
  color: var(--text-primary);
}

.form-input::placeholder,
.form-textarea::placeholder {
  color: var(--text-muted);
}

.form-input:focus,
.form-textarea:focus {
  outline: none;
  border-color: #25D366;
  box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.1);
  background: var(--input-background);
}

[data-theme="dark"] .form-input:focus,
[data-theme="dark"] .form-textarea:focus {
  box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.2);
}

.form-textarea {
  resize: vertical;
  font-family: 'Courier New', monospace;
}

.form-hint {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.875rem;
  color: var(--text-muted);
  margin-top: 0.25rem;
}

.toggle-container {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--bg-tertiary);
  transition: 0.3s;
  border-radius: 24px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: var(--card-background);
  transition: 0.3s;
  border-radius: 50%;
}

.toggle-switch input:checked + .toggle-slider {
  background-color: #25D366;
}

.toggle-switch input:checked + .toggle-slider:before {
  transform: translateX(26px);
}

.toggle-label {
  font-weight: 500;
  color: var(--text-primary);
}

.form-footer {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--border-color);
}

.btn {
  padding: 12px 25px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background: #25D366;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: #20ba5a;
  transform: translateY(-1px);
}

.btn-secondary {
  padding: 10px 16px;
  border: 1px solid var(--border-color, rgba(0, 0, 0, 0.12));
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.875rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
  background: var(--bg-secondary, #f3f4f6);
  color: var(--text-primary, #111827);
}

.btn-secondary:hover {
  background: var(--card-bg, #fff);
  border-color: var(--accent-color, #3b82f6);
  color: var(--accent-color, #3b82f6);
  transform: translateY(-1px);
}

.btn-secondary i {
  font-size: 0.85em;
}

[data-theme="dark"] .btn-secondary {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.22);
  color: #f3f4f6;
}

[data-theme="dark"] .btn-secondary:hover {
  background: rgba(59, 130, 246, 0.25);
  border-color: #60a5fa;
  color: #dbeafe;
}

[data-theme="dark"] .btn-secondary i {
  color: inherit;
}

.info-message {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  background: rgba(59, 130, 246, 0.1);
  border-radius: 8px;
  color: var(--accent-color);
  border: 1px solid var(--border-color);
}

[data-theme="dark"] .info-message {
  background: rgba(96, 165, 250, 0.15);
}

.info-message i {
  font-size: 1.25rem;
}

.info-message p {
  margin: 0;
}

.placeholders-info {
  margin-top: 1rem;
  padding: 1rem;
  background: var(--bg-secondary);
  border-radius: 8px;
  border: 1px solid var(--border-color);
}

.placeholders-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  color: var(--text-primary);
  font-size: 0.9rem;
}

.placeholders-header i {
  color: #25D366;
}

.placeholders-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.placeholder-group {
  background: var(--input-background);
  border-radius: 8px;
  border: 1px solid var(--border-color);
  margin-bottom: 0.5rem;
  overflow: hidden;
}

.placeholder-group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.85rem 1rem;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
  user-select: none;
  background: var(--bg-secondary, rgba(0, 0, 0, 0.03));
  gap: 12px;
}

.placeholder-group-header:hover {
  background: color-mix(in srgb, var(--accent-color, #3b82f6) 10%, transparent);
}

.placeholder-group-header i {
  color: var(--accent-color, #3b82f6);
  font-size: 0.85rem;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: color-mix(in srgb, var(--accent-color, #3b82f6) 12%, transparent);
  border: 1px solid color-mix(in srgb, var(--accent-color, #3b82f6) 30%, transparent);
  transition: transform 0.2s, background 0.2s;
  flex-shrink: 0;
}

.placeholder-group-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

[data-theme="dark"] .placeholder-group {
  background: rgba(255, 255, 255, 0.03);
  border-color: rgba(255, 255, 255, 0.12);
}

[data-theme="dark"] .placeholder-group-header {
  background: rgba(255, 255, 255, 0.06);
}

[data-theme="dark"] .placeholder-group-header:hover {
  background: rgba(59, 130, 246, 0.18);
}

[data-theme="dark"] .placeholder-group-header i {
  color: #dbeafe;
  background: rgba(37, 99, 235, 0.45);
  border-color: #60a5fa;
}

[data-theme="dark"] .placeholder-group-title {
  color: #f3f4f6;
}

.placeholder-list {
  padding: 0 0.75rem 0.75rem 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  animation: slideDown 0.2s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    max-height: 0;
  }
  to {
    opacity: 1;
    max-height: 1000px;
  }
}

.placeholder-tag {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  background: linear-gradient(135deg, #25D366, #20ba5a);
  color: white;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  user-select: all;
}

.placeholder-tag:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(37, 211, 102, 0.3);
}

.btn-placeholders {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s;
  margin-left: 0.5rem;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

.btn-placeholders:hover {
  background: var(--accent-color);
  color: white;
  border-color: var(--accent-color);
}

.placeholders-modal {
  max-width: 600px;
}

.ranking-modal {
  max-width: 700px;
}

.placeholder-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid var(--border-color);
}

.placeholder-item:last-child {
  border-bottom: none;
}

.placeholder-desc {
  color: var(--text-secondary);
  font-size: 0.875rem;
  flex: 1;
}

.placeholder-description {
  display: block;
  font-size: 0.75rem;
  color: var(--text-muted);
  margin-top: 0.5rem;
  line-height: 1.4;
}

.schedule-section {
  margin-top: 2rem;
}

.schedules-list {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}

.schedule-card {
  background: var(--card-background);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 1.25rem;
  transition: var(--transition);
  box-shadow: var(--shadow-sm);
}

.schedule-card:hover {
  box-shadow: var(--shadow-md);
}

.schedule-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.schedule-info {
  flex: 1;
}

.schedule-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 0.5rem 0;
}

.schedule-details {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: var(--text-secondary);
  margin: 0.25rem 0;
}

.schedule-details i {
  color: #25D366;
  width: 16px;
}

.schedule-status {
  margin-left: 1rem;
}

.schedule-actions {
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border-color);
}

.schedule-form {
  background: var(--card-bg);
  border: 1px solid var(--card-border);
  border-radius: 8px;
  padding: 20px;
  margin-top: 20px;
  box-shadow: var(--shadow-sm);
}

.empty-state-hint {
  font-size: 0.875rem;
  color: var(--text-muted);
  margin-top: 0.5rem;
}

.templates-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
  background: var(--bg-secondary);
  border-radius: 6px;
  border: 1px solid var(--border-color);
  max-height: 200px;
  overflow-y: auto;
}

.template-checkbox-item {
  display: flex;
  align-items: center;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  user-select: none;
}

.checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #25D366;
}

.checkbox-text {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: var(--text-primary);
}

.checkbox-text i {
  color: #25D366;
}

/* Modal de Teste */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.modal-content {
  background: var(--card-bg);
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--card-border);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid var(--border-color);
}

.modal-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.modal-title i {
  color: #25D366;
}

.modal-close {
  background: none;
  border: none;
  font-size: 1.25rem;
  color: var(--text-muted);
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  transition: var(--transition);
}

.modal-close:hover {
  background: var(--bg-secondary);
  color: var(--text-primary);
}

.modal-body {
  padding: 1.5rem;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1.5rem;
  border-top: 1px solid var(--border-color);
}

.test-preview {
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--border-color);
}

.test-preview .preview-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-secondary);
  margin: 0 0 0.5rem 0;
}

.test-preview .preview-content {
  background: var(--input-background);
  padding: 1rem;
  border-radius: 6px;
  border: 1px solid var(--border-color);
  white-space: pre-wrap;
  font-family: 'Courier New', monospace;
  font-size: 0.875rem;
  color: var(--text-primary);
  max-height: 200px;
  overflow-y: auto;
}
</style>

